const tr = {
  common: {
    close: "Kapat",
    loadMore: "Daha fazla yükle",
    shownCount: "{{count}} kayıt gösteriliyor",
    error: "Hata",
    warning: "Uyarı",
    success: "Başarılı",
    cancel: "İptal",
    delete: "Sil",
    save: "Kaydet",
    edit: "Düzenle",
    create: "Oluştur",
    ok: "Tamam",
    loading: "Yükleniyor...",
    retry: "Tekrar Dene",
    back: "Geri",
    share: "Paylaş",
    download: "İndir",
    rename: "Yeniden Adlandır",
    remove: "Kaldır",
    na: "Yok",
    user: "Kullanıcı",
    signInRequired: "Giriş Gerekli",
    guestRestricted: "Bu özelliğe erişmek için lütfen giriş yapın.",
    info: "Bilgi",
    refresh: "Yenile"
  },
  auth: {
    login: {
      title: "Future Document",
      subtitle: "Kurumsal Bulut Dosya Yönetim Yazılımı",
      email: "E-posta",
      emailPlaceholder: "example@email.com",
      password: "Şifre",
      passwordPlaceholder: "••••••••",
      forgotPassword: "Şifremi Unuttum",
      signIn: "Giriş Yap",
      noAccount: "Hesabınız yok mu? ",
      signUp: "Kayıt Ol",
      licenseLookup: "Lisans Sorgula",
      loginFailed: "Giriş Başarısız",
      emailRequired: "E-posta Gerekli",
      emailRequiredMsg: "Şifrenizi sıfırlamak için lütfen e-posta adresinizi girin.",
      emailSent: "E-posta Gönderildi",
      emailSentMsg: "Şifre sıfırlama bağlantısı gönderildi. (Demo)",
      orContinueWith: "veya şununla devam edin",
      guestLogin: "Misafir Olarak Devam Et",
      guestLoginSubtext: "Giriş yapmadan ana sayfaya göz atın"
    },
    register: {
      title: "Hesap Oluştur",
      subtitle: "Future Document'a Hoş Geldiniz",
      fullName: "Ad Soyad",
      fullNamePlaceholder: "Ad Soyad",
      email: "E-posta",
      emailPlaceholder: "example@email.com",
      password: "Şifre",
      passwordPlaceholder: "••••••••",
      confirmPassword: "Şifreyi Onayla",
      confirmPasswordPlaceholder: "••••••••",
      licenseCode: "Lisans Kodu",
      licenseCodePlaceholder: "XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      acceptTerms: "Kabul ediyorum: ",
      termsOfService: "Kullanım Koşulları",
      and: " ve ",
      privacyPolicy: "Gizlilik Politikası",
      signUp: "Kayıt Ol",
      hasAccount: "Zaten hesabınız var mı? ",
      signIn: "Giriş Yap",
      veryWeak: "Çok Zayıf",
      weak: "Zayıf",
      medium: "Orta",
      strong: "Güçlü",
      veryStrong: "Çok Güçlü",
      fullNameRequired: "Ad soyad zorunludur",
      fullNameMin: "Ad soyad en az 2 karakter olmalıdır",
      emailRequired: "E-posta adresi zorunludur",
      emailInvalid: "Lütfen geçerli bir e-posta adresi girin",
      passwordRequired: "Şifre zorunludur",
      passwordMin: "Şifre en az 6 karakter olmalıdır",
      confirmPasswordRequired: "Lütfen şifrenizi onaylayın",
      passwordsNoMatch: "Şifreler eşleşmiyor",
      licenseRequired: "Lisans kodu zorunludur",
      licenseInvalid: "Lisans kodu formatı geçersiz (25 karakter bekleniyor)",
      licenseVerifyFailed: "Lisans kodu doğrulanamadı. Lütfen kodunuzu kontrol edip tekrar deneyin.",
      licenseAlreadyActivated: "Bu lisans kodu zaten etkinleştirilmiş.",
      licenseRegionTitle: "Uyarı",
      licenseNotForTurkey: "Bu lisans kodları Türkiye'de kullanılamaz.",
      mustBeSignedIn: "Lisans etkinleştirmek için giriş yapmış olmalısınız.",
      mustAcceptTerms: "Şartlar ve koşulları kabul etmelisiniz.",
      registerError: "Lisansınız doğrulanırken bir hata oluştu. Lütfen tekrar deneyin."
    },
    support: {
      title: "Destek Talebi",
      subtitle: "Lisans kodunuz bulunamadı. Destek ekibimizle iletişime geçmek için lütfen aşağıdaki formu doldurun.",
      searchedLicense: "Aranan Lisans: ",
      fullName: "Ad Soyad *",
      fullNamePlaceholder: "Adınızı ve soyadınızı girin",
      email: "E-posta Adresi *",
      emailPlaceholder: "example@company.com",
      companyName: "Şirket Adı (İsteğe Bağlı)",
      companyNamePlaceholder: "Şirket adınızı girin",
      message: "Mesajınız *",
      messagePlaceholder: "Lisans kodunuzla ilgili sorunu açıklayın...",
      submit: "Talebi Gönder",
      backToLogin: "Girişe Dön",
      fillRequired: "Lütfen tüm zorunlu alanları doldurun.",
      sendError: "Destek talebi gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
      requestReceived: "Talep Alındı!",
      requestReceivedMsg: "Destek talebiniz başarıyla oluşturuldu. En kısa sürede e-posta adresinize yanıt vereceğiz."
    },
    licenseLookup: {
      title: "Lisans Sorgula",
      subtitle: "Lisans bilgilerinizi görüntülemek için 25 karakterlik lisans kodunuzu girin",
      licenseCode: "Lisans Kodu",
      format: "Biçim: XXXXX-XXXXX-XXXXX-XXXXX-XXXXX",
      placeholder: "XXXXX",
      lookup: "Lisansı Sorgula",
      notFoundTitle: "Lisans Bulunamadı",
      notFoundMsg: "Girdiğiniz lisans kodu sistemimizde bulunamadı. Yardım için destek talebi oluşturabilirsiniz.",
      createSupport: "Destek Talebi Oluştur",
      purchaseLicense: "Yeni Lisans Satın Al",
      enterComplete: "Lütfen eksiksiz bir lisans kodu girin",
      lookupError: "Lisansınız sorgulanırken bir hata oluştu. Lütfen tekrar deneyin."
    },
    licenseInfo: {
      title: "Lisans Bilgileri",
      subtitle: "Lisansınıza ait ayrıntılar",
      noData: "Lisans Verisi Yok",
      noDataDesc: "Lütfen önce bir lisans sorgulayın.",
      licenseCode: "Lisans Kodu",
      type: "Lisans Türü",
      maxUsers: "Maks. Kullanıcı",
      activatedBy: "Etkinleştiren",
      expiresAt: "Bitiş Tarihi",
      activated: "Etkinleştirildi",
      available: "Kullanılabilir",
      activateNow: "Şimdi Etkinleştir"
    },
    errors: {
      emailInUse: "Bu e-posta adresi zaten kullanılıyor.",
      invalidEmail: "Geçersiz e-posta adresi.",
      operationNotAllowed: "Bu işlem şu anda kullanılamıyor.",
      weakPassword: "Şifre en az 6 karakter olmalıdır.",
      userDisabled: "Bu hesap devre dışı bırakılmış.",
      userNotFound: "Bu e-posta adresiyle kullanıcı bulunamadı.",
      wrongPassword: "Yanlış şifre.",
      invalidCredential: "Geçersiz giriş bilgileri.",
      tooManyRequests: "Çok fazla başarısız deneme. Lütfen daha sonra tekrar deneyin.",
      networkError: "Ağ bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.",
      generic: "Bir hata oluştu. Lütfen tekrar deneyin.",
      notSignedIn: "Giriş yapılmamış"
    }
  },
  home: {
    goodMorning: "Günaydın",
    goodAfternoon: "İyi Günler",
    goodEvening: "İyi Akşamlar",
    defaultUser: "FutureDoc",
    folders: "Klasörler",
    files: "Dosyalar",
    gbUsage: "GB Kullanımı",
    quickActions: "Hızlı İşlemler",
    upload: "Yükle",
    foldersAction: "Klasörler",
    aiAssistant: "AI Asistan",
    notifications: "Bildirimler",
    recentFiles: "Son Dosyalar",
    seeAll: "Tümünü Gör",
    noFilesYet: "Henüz dosya yüklenmedi",
    uploadFirstFile: "İlk Dosyayı Yükle",
    cloudStorage: "Bulut Depolama",
    storageUsed: "{{used}} GB / {{total}} GB kullanıldı",
    minAgo: "{{count}} dk önce",
    hoursAgo: "{{count}} saat önce",
    daysAgo: "{{count}} gün önce"
  },
  ai: {
    chat: {
      title: "Doküman Asistanı",
      systemMessage: "Merhaba! Ben doküman asistanınızım. Yüklediğiniz dosyalara göre sorularınızı yanıtlayabilirim.",
      welcomeMsg: "Merhaba! Belgelerinizi aramanıza, içerikleri hakkında soruları yanıtlamanıza ve içgörüler sunmanıza yardımcı olabilirim. Ne öğrenmek istersiniz?",
      tempResponse: "Bu özellik API entegrasyonu bekliyor. Lütfen daha sonra tekrar deneyin.",
      guardrails: "Yanıtlar yalnızca yüklediğiniz belgelere dayanır",
      typing: "Belgeler taranıyor...",
      placeholder: "Belgeleriniz hakkında bir soru sorun...",
      sources: "Kaynaklar:",
      page: "Sayfa {{num}}",
      citationTitle: "Kaynak Belge",
      citationInfo: "Kaynak: {{fileName}}\nSayfa: {{page}}",
      citationOpenError: "Kaynak belge açılamadı."
    },
    ocr: {
      title: "OCR Sonucu",
      fileNotFound: "Dosya bulunamadı",
      confidenceScore: "Güven Skoru",
      classification: "Sınıflandırma",
      unidentified: "Tanımlanamadı",
      approvalRequired: "Onay Gerekli (HITL)",
      approvalMsg: "OCR güveni %80'in altında. Lütfen metni inceleyip onaylayın.",
      tags: "Etiketler",
      extractedText: "Çıkarılan Metin",
      characters: "{{count}} karakter",
      noOcrText: "OCR metni bulunamadı.",
      piiTitle: "Hassas Veri Tespit Edildi (PII/DLP)",
      piiMsg: "Bu belgede kimlik numarası, IBAN veya benzeri hassas veri tespit edildi.",
      approveBtn: "OCR Sonucunu Onayla",
      highConfidence: "Yüksek Güven",
      mediumConfidence: "Orta Güven",
      lowConfidence: "Düşük Güven",
      veryLowConfidence: "Çok Düşük Güven",
      loadError: "Dosya yüklenemedi.",
      approved: "Onaylandı",
      approvedMsg: "OCR sonucu onaylandı ve dosya artık hazır.",
      approvalFailed: "Onay işlemi başarısız oldu."
    }
  },
  search: {
    title: "Ara",
    subtitle: "Dosya içeriklerinde, adlarında, etiketlerde ve AI sınıflandırmalarında arayın",
    placeholder: "Dosya, etiket veya içerik ara...",
    pendingApproval: "Onay Bekliyor",
    processing: "İşleniyor",
    scanning: "Taranıyor",
    quarantined: "Karantinada",
    tipsTitle: "Arama İpuçları",
    tipFileName: "Dosya adına göre ara",
    tipTags: "Etiketlere göre ara",
    tipOcr: "OCR metni içinde ara",
    tipAi: "AI sınıflandırmasına göre ara",
    noResults: "Sonuç bulunamadı",
    tryDifferent: "Farklı anahtar kelimeler deneyin veya filtreleri ayarlayın",
    advancedFilters: "Gelişmiş Filtreler",
    recentSearches: "Son Aramalar",
    clearRecent: "Temizle",
    popularTags: "Popüler Etiketler",
    noTagsAvailable: "Etiket yok",
    resultCount: "{{count}} sonuç bulundu (toplam {{total}} dosya)",
    sortBy: "Sırala",
    sortOptions: { relevance: "Alakalılık", date: "Tarih", name: "Ad", size: "Boyut" },
    page: "Sayfa",
    matchTypes: { name: "Ad", tag: "Etiket", content: "İçerik", classification: "Sınıf" },
    columns: { name: "Ad", match: "Eşleşme", score: "Skor", size: "Boyut", status: "Durum", tags: "Etiketler", date: "Tarih" },
    filters: {
      title: "Sonuçları Filtrele",
      fileType: "Dosya Türü",
      status: "Durum",
      folder: "Klasör",
      allFolders: "Tüm Klasörler",
      dateRange: "Tarih Aralığı",
      dateFrom: "Başlangıç",
      dateTo: "Bitiş",
      sizeRange: "Dosya Boyutu",
      sizeMin: "Min (bayt)",
      sizeMax: "Maks (bayt)",
      sizeHint: "Boyut bayt cinsinden (örn. 1048576 = 1 MB)",
      tags: "Etiketler",
      clearAll: "Tümünü Temizle",
      apply: "Uygula",
      types: { all: "Tüm Türler", pdf: "PDF", doc: "Belgeler", image: "Görseller", spreadsheet: "E-tablolar", presentation: "Sunumlar", other: "Diğer" },
      statuses: { all: "Tüm Durumlar", READY: "Hazır", PROCESSING: "İşleniyor", NEED_APPROVAL: "Onay Gerekli", QUARANTINED: "Karantinada" }
    }
  },
  files: {
    move: {
      action: "Taşı",
      title: "\"{{name}}\" öğesini taşı",
      destination: "Hedef klasör",
      root: "Ana dizin (klasörsüz)",
      confirm: "Taşı",
      done: "Taşındı.",
      failed: "Taşıma başarısız oldu.",
      errorSelf: "Klasör kendi içine taşınamaz.",
      errorChild: "Klasör kendi alt klasörüne taşınamaz.",
      errorDepth: "Klasör derinliği sınırı aşılıyor (en fazla 10 seviye).",
      errorMissing: "Öğe veya hedef klasör bulunamadı.",
      newSubfolderIn: "\"{{name}}\" içinde yeni klasör"
    },
    title: "Dosyalarım",
    noFilesYet: "Henüz dosya yok",
    detail: {
      title: "Dosya Ayrıntısı",
      fileNotFound: "Dosya bulunamadı.",
      details: "Ayrıntılar",
      created: "Oluşturulma",
      modified: "Değiştirilme",
      size: "Boyut",
      type: "Tür",
      folder: "Klasör",
      file: "Dosya",
      loadError: "Dosya bilgileri yüklenemedi.",
      preview: "Önizleme",
      tapToPreview: "Önizlemek için dokunun",
      noDownloadUrl: "İndirme URL'si kullanılamıyor.",
      demoDownload: "Demo modunda indirme devre dışı.",
      demoDelete: "Demo modunda silme devre dışı.",
      saveFile: "Dosyayı Kaydet",
      downloadComplete: "Dosya indirildi: {{path}}",
      downloadError: "Dosya indirilemedi.",
      deleteTitle: "Dosyayı Sil",
      deleteMsg: "\"{{name}}\" çöp kutusuna taşınacak. 30 gün içinde geri alabilirsiniz.",
      deleteSuccess: "Dosya başarıyla silindi.",
      deleteError: "Dosya silinemedi.",
      ocrAvailable: "OCR Metni Mevcut",
      ocrDesc: "Çıkarılan metni ve AI önerilerini görüntüleyin",
      versionHistory: "Sürüm Geçmişi",
      versions: "Sürümler",
      noVersions: "Henüz kayıtlı sürüm yok.",
      viewAllVersions: "Tümünü gör",
      versionHistoryDesc: "Önceki sürümleri görüntüleyin ve geri yükleyin"
    },
    preview: {
      title: "Dosya Önizleme",
      loading: "Dosya yükleniyor...",
      loadError: "Dosya yüklenemedi.",
      noUrl: "Dosya URL'si kullanılamıyor.",
      unsupportedType: "Bu dosya türü önizleme için desteklenmiyor.",
      unsupportedTitle: "Önizleme Kullanılamıyor",
      fileNotFound: "Dosya bulunamadı."
    },
    status: {
      scanning: "Taranıyor",
      processing: "İşleniyor",
      need_approval: "Onay Gerekli",
      quarantined: "Karantinada",
      ready: "Hazır"
    },
    upload: {
      quotaWarning: "Kotanızın %80'ine ulaştınız: depolama %{{storage}}, işlem %{{ops}}.",
      quotaBlockedStorage: "Depolama kotanız doldu; bu dosyalar yüklenemez. Yer açın veya planınızı yükseltin.",
      quotaBlockedOps: "Aylık işlem kotanız doldu; yükleme yapılamaz.",
      title: "Dosya Yükle",
      tapToSelect: "Dosyaları buraya tıklayın veya sürükleyin",
      formats: "PDF, DOCX, XLSX, PPTX, JPG, PNG, TIFF",
      maxSize: "Maks. 5 GB",
      tags: "Etiketler (virgülle ayırın)",
      tagsPlaceholder: "fatura, 2026, önemli",
      targetFolder: "Hedef klasör",
      rootFolder: "Kök (klasörsüz)",
      selectedFiles: "Seçilen Dosyalar ({{count}})",
      notProcessable: "İşlenemez (>500MB)",
      uploadBtn: "{{count}} Dosya Yükle",
      sizeError: "Boyut Hatası",
      sizeErrorMsg: "{{name}} 5 GB sınırını aşıyor.",
      selectWarning: "Lütfen en az bir dosya seçin.",
      uploadComplete: "Yükleme Tamamlandı",
      uploadSuccessMsg: "{{success}} dosya başarıyla yüklendi!",
      uploadPartialMsg: "{{success}} dosya yüklendi, {{fail}} dosya başarısız oldu."
    },
    versions: {
      title: "Sürüm Geçmişi",
      loadError: "Sürüm geçmişi yüklenemedi.",
      versionNum: "Sürüm {{num}}",
      current: "Güncel",
      today: "Bugün",
      yesterday: "Dün",
      daysAgo: "{{count}} gün önce",
      restore: "Geri Yükle",
      restoreTitle: "Sürümü Geri Yükle",
      restoreMsg: "{{version}} sürümünü geri yüklemek istediğinize emin misiniz?",
      restoreSuccess: "Sürüm başarıyla geri yüklendi.",
      restoreConfirm: "Bu işlem geçerli sürümün yerini alacaktır. Geçerli sürümün yedeği otomatik olarak kaydedilir.",
      restoreNote: "Değişiklik notu",
      demoRestore: "Demo modunda sürüm geri yükleme devre dışı.",
      demoDownload: "Demo modunda sürüm indirme devre dışı.",
      noVersions: "Sürüm Geçmişi Yok",
      noVersionsDesc: "Değişiklik yaptıkça sürüm geçmişi burada görünecektir.",
      compareVersions: "Sürümleri Karşılaştır",
      selectSecond: "Karşılaştırmak için bir sürüm daha seçin.",
      readyToCompare: "İki sürüm seçildi — Sürümleri Karşılaştır'a tıklayın.",
      clearSelection: "Seçimi temizle",
      changeNote: "Değişiklik Notu",
      changeNotePlaceholder: "Bu sürümde ne değiştiğini açıklayın…",
      changeNoteRequired: "Yeni sürüm yüklerken değişiklik notu zorunludur.",
      sizeChange: "Boyut Değişimi",
      totalVersions: "Toplam Sürüm",
      latestSize: "Son Boyut",
      totalSize: "Toplam Boyut",
      fileSize: "Dosya Boyutu",
      preview: "Önizleme",
      download: "İndir",
      previewUnavailable: "Bu dosya türü için önizleme kullanılamıyor.",
      uploadNew: "Yeni Sürüm Yükle",
      selectFile: "Dosya Seç",
      upload: "Yükle",
      uploadSuccess: "Yeni sürüm başarıyla yüklendi.",
      uploadError: "Yeni sürüm yüklenemedi.",
      demoUpload: "Demo modunda sürüm yükleme devre dışı.",
      older: "Daha Eski",
      newer: "Daha Yeni"
    },
    share: {
      byRole: "Rol bazlı paylaşım",
      byRoleHint: "Şirketinizde seçtiğiniz rollere sahip tüm kullanıcılar dosyaya erişir. Başka şirketlerdeki aynı roller erişemez.",
      saveRoles: "Rol paylaşımını kaydet",
      rolesSaved: "Dosya {{count}} rolle paylaşıldı.",
      rolesCleared: "Rol paylaşımı kaldırıldı.",
      rolesFailed: "Rol paylaşımı kaydedilemedi.",
      rolesNoCompany: "Rol bazlı paylaşım için hesabınızın bir şirkete bağlı olması gerekir.",
      sharedWithMyRole: "Rolümle paylaşılanlar",
      title: "Dosya Paylaş",
      newShare: "Yeni Paylaşım",
      emailAddress: "E-posta Adresi",
      emailPlaceholder: "user@company.com",
      permissionLevel: "İzin Seviyesi",
      timeLimit: "Süre Limiti (gün, isteğe bağlı)",
      timeLimitPlaceholder: "Sınırsız",
      shareBtn: "Paylaş",
      sharedWith: "Paylaşılan Kişiler ({{count}})",
      notSharedYet: "Henüz kimseyle paylaşılmadı",
      view: "Görüntüle",
      editPerm: "Düzenle",
      downloadPerm: "İndir",
      loadError: "Veriler yüklenemedi.",
      emailEmpty: "Lütfen bir e-posta adresi girin.",
      emailInvalid: "Lütfen geçerli bir e-posta adresi girin.",
      shareSuccess: "Dosya {{email}} ile paylaşıldı.",
      shareFailed: "Paylaşım başarısız oldu.",
      revokeTitle: "Paylaşımı İptal Et",
      revokeMsg: "{{email}} için erişim kaldırılacak.",
      revokeFailed: "İptal işlemi başarısız oldu."
    },
    trash: {
      title: "Çöp Kutusu",
      retention: "Silinen öğeler {{count}} gün sonra kalıcı olarak silinir.",
      empty: "Çöp kutusu boş",
      name: "Ad",
      deletedAt: "Silinme tarihi",
      purgeIn: "Kalıcı silinmesine",
      days: "{{count}} gün",
      folder: "Klasör",
      restore: "Geri al",
      deleteForever: "Kalıcı olarak sil",
      emptyTrash: "Çöp kutusunu boşalt",
      emptyConfirm: "Çöp kutusundaki tüm öğeler kalıcı olarak silinecek. Bu işlem geri alınamaz.",
      deleteForeverConfirm: "\"{{name}}\" kalıcı olarak silinecek. Bu işlem geri alınamaz.",
      loadError: "Çöp kutusu yüklenemedi.",
      actionError: "İşlem tamamlanamadı. Lütfen tekrar deneyin."
    },
    folders: {
      title: "Klasörler",
      fileCount: "{{count}} dosya",
      noFoldersYet: "Henüz klasör yok",
      noFoldersMsg: "Dosyalarınızı düzenlemek için yeni bir klasör oluşturun.",
      newFolder: "Yeni Klasör",
      folderName: "Klasör adı",
      newName: "Yeni ad",
      deleteFolder: "Klasörü Sil",
      deleteFolderMsg: "\"{{name}}\" klasörü ve içindeki dosyalar çöp kutusuna taşınacak; alt klasörler bir üst klasöre taşınır. 30 gün içinde geri alabilirsiniz.",
      folderCreated: "Klasör oluşturuldu!",
      loadError: "Klasörler yüklenemedi.",
      createError: "Klasör oluşturulamadı.",
      renameError: "Klasör yeniden adlandırılamadı.",
      deleteError: "Klasör silinemedi.",
      nameEmpty: "Klasör adı boş olamaz."
    }
  },
  settings: {
    title: "Ayarlar",
    account: "Hesap",
    application: "Uygulama",
    supportSection: "Destek",
    profile: "Profil",
    profileDesc: "Hesap bilgilerinizi yönetin",
    notifications: "Bildirimler",
    notificationsDesc: "Bildirim tercihleri",
    security: "Güvenlik",
    securityDesc: "2FA ve güvenlik ayarları",
    workspace: "Çalışma Alanı",
    workspaceDesc: "Çalışma alanları arasında geçiş yapın",
    storage: "Depolama",
    storageDesc: "Kota ve kullanım bilgileri",
    appearance: "Görünüm",
    appearanceDesc: "Tema ve görüntüleme tercihleri",
    language: "Dil",
    languageDesc: "Uygulama dili seçimi",
    adminPanel: "Yönetici Paneli",
    adminPanelDesc: "Şirket bilgisi, ekip kullanıcıları, kota ve denetim kayıtları",
    helpSupport: "Yardım ve Destek",
    helpSupportDesc: "SSS ve destek talepleri",
    helpSupportMsg: "Destek için support@futuredocument.com adresine e-posta gönderebilirsiniz.",
    privacyPolicy: "Gizlilik Politikası",
    privacyPolicyDesc: "Veri gizliliği politikaları",
    termsOfService: "Kullanım Koşulları",
    termsOfServiceDesc: "Hizmet şartları ve koşulları",
    kvkk: "KVKK Aydınlatma Metni",
    kvkkDesc: "Kişisel verilerin korunması aydınlatma metni",
    distanceSales: "Mesafeli Satış Sözleşmesi",
    distanceSalesDesc: "Dijital hizmetler için mesafeli satış sözleşmesi",
    deliveryConditions: "Teslimat ve Hizmet Koşulları",
    deliveryConditionsDesc: "Aktivasyon, destek ve hizmet sunumu",
    cancellationReturn: "İptal, İade ve Cayma",
    cancellationReturnDesc: "İptal, iade ve cayma şartları",
    about: "Hakkında",
    aboutDesc: "Uygulama sürüm bilgisi",
    aboutMsg: "Sürüm 1.0.0\n© 2026 Future Tech Works Software Company",
    signOut: "Çıkış Yap",
    signOutConfirm: "Çıkış yapmak istediğinize emin misiniz?",
    comingSoon: "Demo modunda erişim kısıtlıdır.",
    version: "FutureDoc v1.0.0"
  },
  profile: {
    title: "Profil",
    profileInfo: "Profil Bilgileri",
    name: "Ad",
    namePlaceholder: "Adınız",
    email: "E-posta",
    userId: "Kullanıcı ID",
    emailVerified: "E-posta Doğrulandı",
    emailNotVerified: "E-posta Doğrulanmadı",
    changePassword: "Şifre Değiştir",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    confirmNewPassword: "Yeni Şifreyi Onayla",
    updatePassword: "Şifreyi Güncelle",
    deleteAccount: "Hesabı Sil",
    deleteAccountMsg: "Bu işlem geri alınamaz. Tüm verileriniz silinecektir.",
    deleteMyAccount: "Hesabımı Sil",
    nameEmpty: "Ad boş olamaz.",
    profileUpdated: "Profiliniz güncellendi.",
    profileUpdateError: "Profil güncellenemedi.",
    fillAllFields: "Lütfen tüm alanları doldurun.",
    passwordMinLength: "Yeni şifre en az 6 karakter olmalıdır.",
    passwordsNoMatch: "Şifreler eşleşmiyor.",
    passwordUpdated: "Şifreniz güncellendi.",
    wrongPassword: "Mevcut şifre yanlış.",
    passwordChangeError: "Şifre değiştirilemedi.",
    accountDeleted: "Hesap Silindi",
    accountDeletedMsg: "Hesabınız ve tüm verileriniz silindi.",
    deleteError: "Hesap silinemedi."
  },
  admin: {
    deactivateUser: "Pasife al",
    activateUser: "Aktif et",
    inactiveBadge: "PASİF",
    confirmDeactivate: "{{email}} pasife alınsın mı? Kullanıcı hemen oturumdan çıkarılır ve tekrar giriş yapamaz.",
    userDeactivated: "{{email}} pasife alındı.",
    userActivated: "{{email}} yeniden aktif.",
    userStatusFailed: "Kullanıcı durumu değiştirilemedi.",
    title: "Yönetici Paneli",
    orgPanelTitle: "Yönetici Paneli",
    orgPanelSubtitle: "Şirket ve ekip hesaplarınızı yönetin",
    orgPanelSubtitleCompany: "{{name}} yönetiliyor",
    platformPanelSubtitle: "Platform genelinde kullanıcı, rol ve lisans yönetimi",
    companyTab: "Şirket",
    teamTab: "Ekibim",
    soldCompaniesTab: "Satılan Şirketler",
    soldCompaniesHelp: "Yönetici hesabınız altında lisans satın alan Şirket rolündeki firmalar. Lisans bağlantılarını ve alt bayileri/kullanıcıları görüntüleyin.",
    drpackLicensesTitle: "Tüm Lisanslar",
    drpackLicensesHelp: "Firebase lisanslarından salt okunur kopya. Kaynak lisans tablosu asla değiştirilmez.",
    syncDrpackLicenses: "Lisanslardan senkronize et",
    drpackSynced: "{{count}} lisans AdminLicenses'e senkronize edildi.",
    drpackSyncError: "Lisanslar senkronize edilemedi.",
    drpackLoadError: "Lisanslar yüklenemedi.",
    drpackSyncedCount: "Senkronize lisanslar",
    drpackCountriesCount: "Ülkeler",
    drpackCompaniesCount: "Kullanan şirketler",
    drpackUsedCount: "Kullanılan lisanslar",
    drpackActivatedCount: "Etkinleştirildi",
    drpackAvailableCount: "Kullanılabilir",
    searchDrpackLicenses: "Ülke, kullanan şirket, kod ile ara…",
    noDrpackLicenses: "AdminLicenses'te henüz lisans yok.",
    noDrpackLicensesHint: "Kayıtları licenses'ten AdminLicenses'e kopyalamak için “Lisanslardan senkronize et”e tıklayın.",
    groupByCountry: "Atanan ülkeye göre",
    groupByUsingCompany: "Kullanan şirkete göre",
    drpackUnknownCountry: "Bilinmeyen ülke",
    drpackUnassignedCompany: "Atanmamış şirket",
    drpackLicenseUnit: "lisans",
    drpackAssignedCountry: "Atanan ülke",
    drpackUsingCompany: "Kullanan şirket",
    drpackSoldTo: "Satılan (satıcı)",
    drpackValidUntil: "Geçerlilik tarihi",
    drpackUsed: "Kullanıldı",
    drpackUnused: "Kullanılmadı",
    drpackType: "Tür",
    drpackStatus: "Durum",
    drpackMaxUsers: "Maks. kullanıcı",
    drpackActivated: "Etkinleştirildi",
    drpackAvailable: "Kullanılabilir",
    drpackLicenseDetail: "Lisans ayrıntısı",
    drpackActivatedBy: "Etkinleştiren",
    drpackSource: "Kaynak",
    drpackRawFields: "Lisans alanları",
    soldCompaniesTotal: "Satılan şirketler",
    soldCompaniesWithLicense: "Lisans kodu olanlar",
    soldCompaniesNetwork: "Ağ hesapları",
    searchSoldCompanies: "Şirket ara",
    searchSoldCompaniesPlaceholder: "Ad, e-posta, lisans, ülke…",
    noSoldCompanies: "Henüz satılan şirket yok",
    noSoldCompaniesDesc: "Lisans sattığınız yurt dışı alıcılar için Şirket rolünde hesap oluşturun.",
    addCompanyAccount: "Şirket Ekle",
    addCompanyHelp: "Yurt dışı alıcı için Şirket rolünde hesap oluşturun (örn. Erbil Plastic). Ticari unvan ve isteğe bağlı şirket ayrıntılarını doldurun.",
    viewCompany: "Görüntüle",
    editSoldCompany: "Şirketi düzenle",
    soldCompanyDetail: "Şirket ayrıntısı",
    soldCompanyInfoHelp: "Bu satılan şirketin adını ve profilini düzenleyin. Ticari unvan zorunlu; diğer alanlar isteğe bağlıdır.",
    soldCompanyInfoRequired: "Şirket hesapları için ticari unvan zorunludur.",
    soldCompanyUpdated: "Şirket bilgileri güncellendi.",
    licenseCode: "Lisans kodu",
    licenseLinkedViaRole: "Şirket rolü ile bağlandı",
    networkSize: "Ağ",
    companyNetwork: "Bu şirket altındaki hesaplar",
    companyNetworkEmpty: "Bu şirket altında henüz bayi, kullanıcı veya görüntüleyici yok.",
    orgCompanyIntro: "Lisanslı şirket profilinizi güncelleyin. Yönetici hesapları için zorunludur.",
    orgUsersHelp: "Organizasyonunuz altındaki Şirket, Bayi, Kullanıcı ve Görüntüleyici hesaplarını yönetebilirsiniz.",
    addTeamUser: "Ekip Kullanıcısı Ekle",
    saveCompany: "Şirket Bilgisini Kaydet",
    companySaved: "Şirket bilgileri kaydedildi.",
    companySaveError: "Şirket bilgileri kaydedilemedi.",
    cannotEditPeerAdmin: "Diğer Yönetici hesaplarını düzenleyemezsiniz.",
    myLicensesTab: "Lisanslarım",
    myLicensesIntro: "Şirketinize tanımlı lisanslar; ürün, satıcı ve geçerlilik bilgileriyle.",
    myLicensesTotal: "Toplam lisans",
    myLicensesValid: "Geçerli lisans",
    myLicenseProduct: "Ürün",
    myLicenseValid: "Geçerli",
    myLicenseExpired: "Süresi doldu",
    searchMyLicenses: "Kod, ürün, satıcı veya tarihe göre ara…",
    noMyLicenses: "Lisans bulunamadı.",
    quotaTab: "Kota ve Kullanım",
    auditTab: "Denetim Kayıtları",
    lookupLogsTab: "Lisans Sorguları",
    lookupLogsLoadError: "Lisans sorgu kayıtları yüklenemedi. Tam Yönetici Firestore iznini kontrol edin.",
    lookupLogsIntro: "Herkese açık site ve portal üzerindeki her sorgu ayrı satır olarak kaydedilir; aynı lisans tekrar tekrar sorgulansa da her seferi tutulur. Yalnızca Tam Yönetici görür.",
    lookupRepeatCount: "{{count}} sorgu",
    lookupTotalSummary: "{{total}} sorgu · {{unique}} farklı lisans",
    lookupLogsSearch: "Anahtar, IP, şehir, ülke veya ISS ile ara…",
    noLookupLogs: "Henüz lisans sorgusu yok",
    lookupColTime: "Zaman",
    lookupColKey: "Lisans anahtarı",
    lookupColStatus: "Durum",
    lookupColIp: "IP",
    lookupColLocation: "Şehir / Ülke",
    lookupColIsp: "ISS",
    lookupColDevice: "Cihaz / PC",
    lookupColSource: "Kaynak",
    lookupRefresh: "Yenile",
    lookupSourcePublic: "Herkese açık site",
    lookupSourcePortal: "Portal",
    lookupSourceMobile: "Mobil uygulama",
    lookupDetailUa: "Tarayıcı (user agent)",
    lookupDetailLang: "Dil",
    lookupDetailTz: "Saat dilimi",
    lookupDetailCoords: "Koordinat",
    lookupDetailPage: "Sayfa",
    lookupDetailReferrer: "Yönlendiren",
    lookupStatus_valid: "Geçerli",
    lookupStatus_expired: "Süresi dolmuş",
    lookupStatus_revoked: "İptal",
    lookupStatus_pending: "Beklemede",
    lookupStatus_not_found: "Bulunamadı",
    lookupStatus_invalid_format: "Geçersiz format",
    lookupStatus_error: "Hata",
    lookupStatus_unknown: "Bilinmiyor",
    loginLogsTab: "Giriş Kayıtları",
    loginLogsLoadError: "Giriş kayıtları yüklenemedi. Tam Yönetici Firestore iznini kontrol edin.",
    loginLogsIntro: "Web paneli, iOS ve Android uygulamalarından her başarılı giriş zaman, IP ve cihaz bilgisiyle Firebase’e kaydedilir. Yalnızca Tam Yönetici görür.",
    loginLogsSearch: "E-posta, IP, şehir, ülke, ISS veya cihaz ile ara…",
    noLoginLogs: "Henüz giriş kaydı yok",
    loginColUser: "Kullanıcı",
    loginTotalSummary: "{{total}} giriş",
    loginSourceWeb: "Web paneli",
    loginSourceIos: "iOS",
    loginSourceAndroid: "Android",
    loginDetailDevice: "Cihaz adı",
    loginDetailOs: "İşletim sistemi",
    usersTab: "Kullanıcılar ve Roller",
    rolesTab: "Rol İzinleri",
    monthlyQuota: "Aylık İşlem Kotası",
    used: "kullanıldı",
    quotaWarning: " ⚠️ Kota limitine yaklaşıyorsunuz!",
    burstCapacity: "Anlık kapasite: {{count}} işlem",
    storageUsage: "Depolama Kullanımı",
    concurrentUsers: "Eşzamanlı Kullanıcılar",
    active: "Aktif",
    limit: "Sınır",
    licenseInfo: "1 Lisans = 20 Eşzamanlı Kullanıcı",
    aiTokenUsage: "AI Token Kullanımı",
    tokens: "{{count}} token",
    tokenDesc: "Bu ayın AI işleme tüketimi",
    noAuditLogs: "Henüz denetim kaydı yok",
    searchUsers: "Kullanıcı ara",
    searchUsersPlaceholder: "E-posta, ad veya rol…",
    usersHierarchyHelp: "Hiyerarşi: Tam Yönetici → Yönetici (toplu lisans) → Şirket (yurt dışı) → Bayi → Kullanıcı → Görüntüleyici. Hesapları bağlamak için üst hesap atayın.",
    user: "Kullanıcı",
    role: "Rol",
    parent: "Üst hesap",
    noParent: "Üst hesap yok",
    parentHelp: "Üst hesap organizasyon ağacını tanımlar (örn. Şirket altındaki Bayi).",
    actions: "İşlemler",
    noUsers: "Kullanıcı bulunamadı.",
    editRole: "Rolü düzenle",
    addUser: "Kullanıcı Ekle",
    addUserHelp: "Yönetici, Şirket, Bayi, Kullanıcı veya Görüntüleyici hesapları oluşturun. Yönetici ve Şirket şirket ayrıntıları içerebilir. Tam Yönetici buradan oluşturulamaz.",
    createUser: "Kullanıcı Oluştur",
    addDisplayName: "Ad soyad",
    addDisplayNamePlaceholder: "örn. Acme Şirket Yöneticisi",
    addEmail: "E-posta",
    addPassword: "Şifre",
    addConfirmPassword: "Şifreyi onayla",
    addNameRequired: "Ad soyad zorunludur (en az 2 karakter).",
    addEmailRequired: "E-posta zorunludur.",
    addEmailInvalid: "E-posta formatı geçersiz.",
    addEmailInUse: "Bu e-posta zaten kayıtlı.",
    addEmailReserved: "Bu e-posta platform Tam Yöneticisi için ayrılmıştır.",
    addPasswordMin: "Şifre en az 6 karakter olmalıdır.",
    addPasswordsNoMatch: "Şifreler eşleşmiyor.",
    userCreated: "{{email}} kullanıcısı {{role}} olarak oluşturuldu.",
    userCreateError: "Kullanıcı oluşturulamadı.",
    companyInfoTitle: "Şirket Bilgileri",
    companyInfoHelp: "Yönetici rolü için zorunlu. Bu hesabı lisanslı şirket olarak kaydeder (Şirket rolünden farklıdır).",
    companyInfoRequired: "Yönetici rolü için şirket bilgileri zorunludur.",
    companyTradeName: "Ticari unvan",
    companyTradeNamePlaceholder: "Yasal / ticari şirket adı",
    companyTaxId: "Vergi No / KDV No",
    companyTaxIdPlaceholder: "örn. 1234567890",
    companyAddress: "Adres",
    companyAddressPlaceholder: "Tam iş adresi",
    companyPhone: "Telefon",
    companyEmail: "Şirket e-postası",
    companyWebsite: "Web sitesi",
    companyDiscountRate: "İndirim oranı (%)",
    companyCountry: "Ülke",
    companyCountryPlaceholder: "örn. Türkiye",
    companyCity: "Şehir",
    companyCityPlaceholder: "örn. İstanbul",
    companyRegion: "Bölge / Eyalet",
    companyRegionPlaceholder: "örn. Marmara",
    companySectors: "Hizmet sektörü kategorileri",
    companySectorsHelp: "Bir veya daha fazla sektör seçin (örn. Ambalaj, Gıda).",
    sector_packaging: "Ambalaj",
    sector_food: "Gıda",
    sector_electronics: "Elektronik",
    sector_textile: "Tekstil",
    sector_automotive: "Otomotiv",
    sector_chemicals: "Kimya",
    sector_construction: "İnşaat",
    sector_pharma: "İlaç",
    sector_logistics: "Lojistik",
    sector_retail: "Perakende",
    sector_agriculture: "Tarım",
    sector_other: "Diğer",
    errCompanyTradeName: "Ticari unvan zorunludur.",
    errCompanyTaxId: "Vergi numarası zorunludur.",
    errCompanyAddress: "Adres zorunludur.",
    errCompanyPhone: "Telefon zorunludur.",
    errCompanyEmail: "Geçerli şirket e-postası zorunludur.",
    errCompanyCountry: "Ülke zorunludur.",
    errCompanyCity: "Şehir zorunludur.",
    errCompanyRegion: "Bölge zorunludur.",
    errCompanySectors: "En az bir sektör kategorisi seçin.",
    errCompanyDiscount: "İndirim oranı 0 ile 100 arasında olmalıdır.",
    roleUpdated: "Kullanıcı rolü güncellendi.",
    roleUpdateError: "Rol güncellenemedi.",
    usersLoadError: "Kullanıcılar yüklenemedi.",
    cannotAssignRole: "Bu rolü atayamazsınız.",
    cannotEditFullAdmin: "Yalnızca Tam Yönetici, Tam Yönetici hesaplarını değiştirebilir.",
    fullAdminLocked: "Platform Tam Yönetici e-postası düşürülemez.",
    rolesHelp: "Rol izinleri Firestore'da (roles koleksiyonu) saklanır. Senkronizasyon varsayılan izin matrisini yazar.",
    syncRolesFirebase: "Rolleri Firebase'e senkronize et",
    rolesSeeded: "{{count}} rol Firebase'e senkronize edildi.",
    rolesSeedError: "Roller senkronize edilemedi.",
    role_full_admin: "Tam Yönetici",
    role_admin: "Yönetici",
    role_company: "Şirket",
    role_dealer: "Bayi",
    role_user: "Kullanıcı",
    role_viewer: "Görüntüleyici",
    role_auditor: "Denetçi / Yerel muhasebeci",
    roleDesc_full_admin: "Platform sahibi — kullanıcı ve rol yönetimi dahil tam erişim.",
    roleDesc_admin: "Toplu lisans alıcı şirket — şirket ayrıntıları zorunlu; lisansları ve organizasyon kullanıcılarını yönetir.",
    roleDesc_company: "Yurt dışı lisans alıcısı — bayileri ve şirket operasyonlarını yönetir.",
    roleDesc_dealer: "Şirket altındaki alt bayi — bayi kullanıcılarını yönetir.",
    roleDesc_user: "Bayi altındaki operasyonel hesap — okuma/yazma modülleri.",
    roleDesc_viewer: "Salt görüntüleme lisans hesabı — yazma işlemi yok.",
    roleDesc_auditor: "Şirketin fatura, cari, ekstre ve belgelerini yalnızca okur; yazma izni yok."
  },
  notif: {
    title: "Bildirimler",
    titleWithCount: "Bildirimler ({{count}})",
    markAllRead: "Tümünü Okundu İşaretle",
    justNow: "Az önce",
    minAgo: "{{count}} dk önce",
    hoursAgo: "{{count}} saat önce",
    daysAgo: "{{count}} gün önce",
    empty: "Bildirim yok",
    emptyDesc: "Dosya paylaşımları, OCR sonuçları ve kota uyarıları burada görünecektir."
  },
  licenseRenewal: {
    title: "Lisans Yenileme",
    intro: "Yenilemek istediğiniz lisansları ve adetleri seçin. Talebiniz onay için lisans sağlayıcınıza gönderilir.",
    requestButton: "Yenileme talebi",
    selectTitle: "Yenilenecek lisanslar",
    sentTo: "Talep {{seller}} firmasına gönderilecek",
    noAdmin: "Hesabınız bir lisans sağlayıcısına bağlı değil. Lütfen destek ile iletişime geçin.",
    adminFallback: "Lisans sağlayıcı",
    noLicenses: "Şirketinize tanımlı lisans bulunmuyor.",
    currentCount: "{{count}} lisans",
    expiredCount: "{{count}} süresi dolmuş",
    selectedCount: "{{count}} seçili",
    renewQuantity: "Yenilenecek adet",
    chooseLicenses: "Lisansları seç",
    hideLicenses: "Lisansları gizle",
    selectAll: "Tümünü seç",
    selectExpired: "Süresi dolanları seç",
    clearSelection: "Temizle",
    summaryTitle: "Talep özeti",
    totalQuantity: "Toplam adet",
    noteLabel: "Not",
    notePlaceholder: "Yenileme süresi, ek talepler…",
    submit: "Yenileme talebini gönder",
    submitted: "{{count}} lisans için yenileme talebiniz gönderildi.",
    submitError: "Yenileme talebi gönderilemedi. Lütfen tekrar deneyin.",
    nothingSelected: "En az bir ürün için adet girin.",
    quantityBelowSelection: "{{product}} için adet, seçili lisans sayısından az olamaz.",
    myRequests: "Yenileme taleplerim",
    noRequests: "Henüz yenileme talebi göndermediniz.",
    requestTitle: "Lisans yenileme talebi",
    requestQuantity: "{{count}} lisans",
    items: "Talep edilen lisanslar",
    noSpecificLicenses: "Belirli bir lisans kodu seçilmedi.",
    notifyAdmin: "{{company}}, {{count}} lisansın yenilenmesini talep etti."
  },
  support: {
    title: "Destek Merkezi",
    subtitle: "Taleplerinizi takip edin ve destek ekibiyle tek bir yerden yazışın.",
    newTicket: "Yeni talep",
    loadError: "Talepler yüklenemedi. Lütfen tekrar deneyin.",
    searchPlaceholder: "Konu, talep no veya kişi ara",
    backToList: "Tüm talepler",
    justNow: "az önce",
    you: "Siz",
    unread: "Yeni yanıt",
    scope: {
      mine: "Açtıklarım",
      assigned: "Bana atananlar",
      all: "Tüm talepler",
      public: "Web formu talepleri"
    },
    filter: {
      active: "Aktif",
      unread: "Okunmamış",
      all: "Tümü"
    },
    stats: {
      active: "Aktif talepler",
      unread: "Yeni yanıtlar",
      waiting: "Yanıt bekleyen",
      resolved: "Çözülen"
    },
    status: {
      open: "Açık",
      in_progress: "İşlemde",
      waiting_customer: "Müşteri yanıtı bekleniyor",
      resolved: "Çözüldü",
      closed: "Kapalı"
    },
    priority: {
      P1: "P1 · Acil",
      P2: "P2 · Yüksek",
      P3: "P3 · Normal",
      P4: "P4 · Düşük"
    },
    priorityHint: {
      P1: "İş tamamen durdu. Yalnızca kritik kesintiler için kullanın.",
      P2: "Sizin veya ekibiniz için önemli bir özellik kullanılamıyor.",
      P3: "Bir şey beklendiği gibi çalışmıyor ama geçici bir çözüm var.",
      P4: "Genel soru veya küçük bir sorun; günlük işinizi etkilemiyor."
    },
    sla: {
      P1: "2 saat içinde",
      P2: "8 saat içinde",
      P3: "1 iş günü içinde",
      P4: "3 iş günü içinde"
    },
    periodPriority: {
      month_end: "Ay sonu / beyanname dönemi: kapanışı etkileyen talepler bir seviye yükseltilir.",
      provisional_tax: "Geçici vergi dönemi: kapanışı etkileyen talepler bir seviye yükseltilir.",
      raised: "Öncelik {{from}} → {{to}}."
    },
    mail: {
      ticket: "Talep",
      priority: "Öncelik",
      category: "Konu",
      requester: "Talep eden",
      open: "Aç"
    },
    category: {
      technical: "Teknik sorun",
      accounting: "Muhasebe ve beyanname",
      license: "Lisans",
      billing: "Fatura ve ödeme",
      account: "Hesap ve erişim",
      feature: "Özellik isteği",
      other: "Diğer"
    },
    categoryDesc: {
      technical: "Hata, çökme, senkronizasyon veya yükleme sorunları",
      accounting: "Defter, fatura, kapanış ve vergi beyannameleri",
      license: "Aktivasyon, yenileme veya lisans limitleri",
      billing: "Faturalar, ödemeler ve fiyatlandırma",
      account: "Giriş, şifre, kullanıcılar ve roller",
      feature: "Fikirler ve geliştirme önerileri",
      other: "Yardım almak istediğiniz diğer konular"
    },
    source: {
      web: "Web portalı",
      ios: "iOS uygulaması",
      android: "Android uygulaması"
    },
    empty: {
      title: "Henüz talep yok",
      desc: "Yardıma ihtiyacınız olduğunda bir talep açın, yazışmayı buradan takip edin.",
      filteredTitle: "Eşleşen talep yok",
      filteredDesc: "Farklı bir filtre veya arama deneyin.",
      clearFilters: "Filtreleri temizle"
    },
    public: {
      emptyTitle: "Web formu talebi yok",
      emptyDesc: "Giriş sayfasındaki destek formundan gönderilen talepler burada görünür.",
      intro: "Ziyaretçilerin giriş sayfasındaki destek formundan gönderdiği talepler. E-posta ile yanıtlayıp tamamlandı olarak işaretleyin.",
      reply: "Yanıtla",
      replySubject: "FutureDocs destek talebiniz",
      markDone: "Tamamlandı",
      reopen: "Yeniden aç"
    },
    form: {
      title: "Destek talebi oluştur",
      subtitle: "Ne olduğunu anlatın; net detaylar sorunu daha hızlı çözmemizi sağlar.",
      categoryStep: "Hangi konuda yardıma ihtiyacınız var?",
      categoryRequired: "Lütfen bir konu seçin.",
      detailsStep: "Sorunu anlatın",
      subject: "Konu",
      subjectPlaceholder: "Örn. Fatura PDF'i indirilemiyor",
      subjectRequired: "Lütfen en az 5 karakterlik bir konu girin.",
      description: "Detaylar",
      descriptionPlaceholder: "Ne yapmaya çalışıyordunuz, bunun yerine ne oldu ve ne zamandan beri?",
      descriptionRequired: "Sorunu anlayabilmemiz için lütfen en az {{count}} karakter yazın.",
      descriptionHint: "Tekrarlama adımlarını, hata mesajlarını ve bulunduğunuz sayfayı ekleyin.",
      license: "İlgili lisans",
      optional: "isteğe bağlı",
      noLicense: "Lisansla ilgili değil",
      priorityStep: "Ne kadar acil?",
      submit: "Talebi gönder",
      submitError: "Talep oluşturulamadı. Lütfen tekrar deneyin.",
      routingTitle: "Kim yanıtlayacak?",
      routingProvider: "Lisans sağlayıcınızın destek ekibi",
      routingPlatform: "FutureDocs platform desteği",
      routingDesc: "Her yanıtta bildirim alırsınız; yazışmaya web portaldan veya mobil uygulamadan devam edebilirsiniz.",
      tipsTitle: "Hızlı yanıt için ipuçları",
      tip1: "Her sorun için ayrı talep açmak yazışmayı odaklı tutar.",
      tip2: "Hata mesajını ve soruna yol açan adımları aynen yazın.",
      tip3: "İlgiliyse doküman, fatura veya kayıt numarasını belirtin.",
      slaTitle: "Hedef ilk yanıt süresi"
    },
    quick: {
      looking: "Bize ulaştığınız için teşekkürler, konuyu inceliyoruz.",
      needInfo: "Sorunun ekran görüntüsünü ve soruna yol açan adımları paylaşabilir misiniz?",
      fixed: "Sorun giderildi. Sizin tarafınızda kontrol edip onaylayabilir misiniz?"
    },
    detail: {
      sendError: "Mesajınız gönderilemedi. Lütfen tekrar deneyin.",
      statusError: "Durum güncellenemedi.",
      copy: "Talep numarasını kopyala",
      openedAgo: "{{time}} açıldı",
      createdTitle: "Talebiniz oluşturuldu.",
      createdDesc: "Talep numaranız {{no}}. Yanıt geldiğinde size bildirim göndereceğiz.",
      statusChanged: "{{name}} durumu değiştirdi:",
      staffTag: "Destek",
      sending: "Gönderiliyor...",
      closedNote: "Bu talep kapatıldı. Sorun tekrar ederse yeniden açabilirsiniz.",
      replyReopens: "Yanıt yazın; talep yeniden açılacak",
      placeholder: "Bir mesaj yazın...",
      send: "Gönder",
      shortcut: "Göndermek için Ctrl / Cmd + Enter",
      status: "Durum",
      resolvedPrompt: "Sorununuz çözüldü mü? Talebi kapatın ya da yazışmaya devam etmek için yanıt yazın.",
      requester: "Talep eden",
      handledBy: "İlgilenen",
      handledProvider: "Lisans sağlayıcı desteği",
      handledPlatform: "Platform desteği",
      channel: "Kanal",
      created: "Oluşturulma",
      lastActivity: "Son hareket",
      notFound: "Talep bulunamadı",
      notFoundDesc: "Silinmiş olabilir veya erişim yetkiniz olmayabilir."
    },
    actions: {
      reopen: "Yeniden aç",
      waitCustomer: "Müşteri yanıtı bekle",
      resolve: "Çözüldü olarak işaretle",
      markSolved: "Sorunum çözüldü",
      close: "Talebi kapat"
    }
  },
  nav: {
    trash: "Çöp Kutusu",
    home: "Ana Sayfa",
    files: "Dosyalar",
    search: "Ara",
    settingsTab: "Ayarlar",
    myFiles: "Dosyalarım",
    fileDetail: "Dosya Ayrıntısı",
    uploadFile: "Dosya Yükle",
    folderManagement: "Klasör Yönetimi",
    shareFile: "Dosya Paylaş",
    filePreview: "Dosya Önizleme",
    versionHistory: "Sürüm Geçmişi",
    profile: "Profil",
    notifications: "Bildirimler",
    adminPanel: "Yönetici Paneli",
    licenseRenewal: "Lisans Yenileme",
    support: "Destek Talepleri",
    privacyPolicy: "Gizlilik Politikası",
    termsOfService: "Kullanım Koşulları",
    kvkk: "KVKK Aydınlatma Metni",
    distanceSales: "Mesafeli Satış Sözleşmesi",
    deliveryConditions: "Teslimat ve Hizmet Koşulları",
    cancellationReturn: "İptal, İade ve Cayma",
    aiAssistant: "AI Asistan",
    ocrResult: "OCR Sonucu"
  },
  workspace: {
    selectWorkspace: "Çalışma Alanı Seç",
    selectWorkspaceDesc: "Devam etmek için bir çalışma alanı seçin",
    switched: "Çalışma Alanı Değiştirildi",
    switchedTo: "Artık {{name}} kullanıyorsunuz",
    loadError: "Çalışma alanları yüklenemedi",
    switchError: "Çalışma alanı değiştirilemedi",
    roleOwner: "Sahip",
    roleAdmin: "Yönetici",
    roleMember: "Üye",
    roleViewer: "Görüntüleyici",
    joinWorkspace: "Çalışma Alanına Katıl",
    joinWorkspaceDesc: "Davet kodu girin veya yöneticinizle iletişime geçin",
    currentWorkspace: "Mevcut Çalışma Alanı",
    switchWorkspace: "Çalışma Alanını Değiştir"
  },
  languages: {
    en: "English",
    ar: "العربية",
    tr: "Türkçe",
    selectLanguage: "Dil Seç"
  },
  network: {
    offline: "Çevrimdışısınız. Bazı özellikler kullanılamayabilir.",
    weak: "Zayıf internet bağlantısı algılandı.",
    restored: "Bağlantı yeniden kuruldu!",
    offlineMode: "Çevrimdışı Mod",
    syncPending: "{{count}} değişiklik senkronizasyon bekliyor"
  },
  security: {
    twoFactorAuth: "İki Faktörlü Kimlik Doğrulama",
    sessionHistory: "Oturum Geçmişi"
  },
  errorBoundary: {
    title: "Beklenmeyen Bir Hata Oluştu",
    message: "Uygulama beklenmeyen bir hatayla karşılaştı. Lütfen tekrar deneyin.",
    retry: "Tekrar Dene"
  },
  legal: {
    lastUpdated: "Son güncelleme: Ocak 2026",
    privacyPolicy: {
      title: "Gizlilik Politikası",
      section1Title: "1. Veri Toplama",
      section1: "Future Document, bulut dosya yönetim hizmetlerimizi sunmak için yalnızca gerekli verileri toplar. Buna adınız, e-posta adresiniz ve yüklenen belgeler dahildir.",
      section2Title: "2. Veri Depolama",
      section2: "Tüm veriler, durağan ve aktarım sırasında şifreleme ile Firebase Cloud altyapısında güvenli şekilde saklanır.",
      section3Title: "3. Veri Kullanımı",
      section3: "Verileriniz yalnızca belge depolama, OCR işleme ve AI destekli belge analizi dahil hizmetlerimizi sunmak için kullanılır. Verilerinizi model eğitimi için kullanmayız.",
      section4Title: "4. Veri Paylaşımı",
      section4: "Kişisel verilerinizi yasaların gerektirdiği veya hizmetlerimizi sunmak için gerekli durumlar dışında üçüncü taraflarla satmaz veya paylaşmayız.",
      section5Title: "5. Veri Saklama",
      section5: "Veriler hesabınızın süresi boyunca saklanır. Hesap silindiğinde tüm veriler 30 gün içinde kalıcı olarak kaldırılır.",
      section6Title: "6. Kullanıcı Hakları",
      section6: "Hesap ayarlarınız üzerinden kişisel verilerinize erişme, düzeltme veya silme hakkına her zaman sahipsiniz.",
      section7Title: "7. Çerezler ve Analitik",
      section7: "Kimlik doğrulama ve oturum yönetimi için gerekli çerezleri kullanırız. Analitik veriler hizmetlerimizi iyileştirmek için anonim olarak toplanır.",
      section8Title: "8. İletişim",
      section8: "Gizlilikle ilgili sorularınız için bizimle iletişime geçin:"
    },
    termsOfService: {
      title: "Kullanım Koşulları",
      section1Title: "1. Koşulların Kabulü",
      section1: "Future Document'ı kullanarak bu Kullanım Koşullarını ve Gizlilik Politikamızı kabul etmiş olursunuz.",
      section2Title: "2. Hizmet Açıklaması",
      section2: "Future Document; OCR işleme, AI destekli belge analizi ve güvenli dosya paylaşımı özellikleriyle kurumsal bulut dosya yönetimi sunar.",
      section3Title: "3. Lisans",
      section3: "Hizmete kayıt olmak ve kullanmak için geçerli bir lisans kodu gerekir. Her lisans en fazla 20 eşzamanlı kullanıcıya erişim sağlar.",
      section4Title: "4. Kullanıcı Sorumlulukları",
      section4: "Kullanıcılar, hesap kimlik bilgilerinin gizliliğini korumaktan ve hesapları altındaki tüm etkinliklerden sorumludur.",
      section5Title: "5. Yasak Kullanımlar",
      section5: "Hizmeti yasa dışı amaçlarla veya zararlı içerik yüklemek için kullanamazsınız.",
      section6Title: "6. Hizmet Kullanılabilirliği",
      section6: "%99,9 çalışma süresi hedefleriz ancak kesintisiz hizmeti garanti etmeyiz. Planlı bakımlar önceden duyurulur.",
      section7Title: "7. Fikri Mülkiyet",
      section7: "Kullanıcılar tarafından yüklenen tüm içerik ilgili kullanıcıların mülkiyetinde kalır. Future Document kullanıcı verileri üzerinde mülkiyet hakkı talep etmez.",
      section8Title: "8. Sorumluluk Sınırlaması",
      section8: "Future Tech Works, hizmetlerimizin kullanımından doğan dolaylı, arızi veya sonuçsal zararlardan sorumlu tutulamaz.",
      section9Title: "9. Fesih",
      section9: "Bu koşulları ihlal eden hesapları askıya alma veya sonlandırma hakkını saklı tutarız. Kullanıcılar hesaplarını istediği zaman silebilir."
    }
  },
  service: {
    quotaReached: "Aylık işlem kotanıza ulaşıldı.",
    quotaWarningTitle: "Kota Uyarısı",
    quotaWarningMsg: "Aylık işlem kotanızın %80'ini kullandınız ({{used}}/{{limit}})",
    fileSharedTitle: "Dosya Paylaşıldı",
    fileSharedMsg: "{{name}} sizinle bir dosya paylaştı"
  },
  accounting: {
    title: "Muhasebe",
    invoices: {
      title: "Faturalar",
      totalInvoices: "Toplam Fatura",
      totalAmount: "Toplam Tutar",
      paidAmount: "Ödenen Tutar",
      pendingAmount: "Bekleyen Tutar",
      search: "Fatura ara...",
      allStatuses: "Tüm Durumlar",
      allTypes: "Tüm Türler",
      newInvoice: "Yeni Fatura",
      noInvoices: "Henüz fatura yok",
      createFirst: "İlk faturanızı oluşturun",
      invoiceNo: "Fatura No",
      type: "Tür",
      typeManual: "Manuel",
      customer: "Müşteri",
      vendor: "Tedarikçi",
      date: "Tarih",
      dueDate: "Vade Tarihi",
      issueDate: "Fatura tarihi",
      paidDateLabel: "Ödeme Tarihi",
      status: "Durum",
      statusDraft: "Taslak",
      statusPending: "Beklemede",
      statusApproved: "Onaylandı",
      statusPaid: "Ödendi",
      statusCancelled: "İptal Edildi",
      lineItems: "Kalemler",
      description: "Açıklama",
      descriptionPlaceholder: "Ürün veya hizmet açıklaması",
      quantity: "Adet",
      unitPrice: "Birim Fiyat",
      taxRateLabel: "Vergi %",
      lineTotal: "Toplam",
      subtotal: "Ara Toplam",
      tax: "Vergi",
      grandTotal: "Genel Toplam",
      addItem: "Kalem Ekle",
      summary: "Özet",
      quickInfo: "Hızlı Bilgi",
      itemCount: "{{count}} kalem",
      invoiceInfo: "Fatura Bilgileri",
      currency: "Para Birimi",
      vendorPlaceholder: "Tedarikçi / Satıcı adı",
      customerPlaceholder: "Müşteri / Şirket adı",
      timeline: "Durum Zaman Çizelgesi",
      current: "Güncel",
      relatedFiles: "İlgili Dosyalar",
      noRelatedFiles: "İlgili dosya yok",
      actions: "İşlemler",
      overdue: "Vadesi Geçmiş",
      overdueMsg: "Bu faturanın vadesi geçmiştir.",
      notFound: "Fatura bulunamadı.",
      loadError: "Fatura yüklenemedi.",
      deleteTitle: "Faturayı Sil",
      deleteMsg: "\"{{no}}\" faturasını silmek istediğinize emin misiniz?",
      demoDelete: "Demo modunda silme devre dışı.",
      demoSave: "Fatura demo modunda kaydedildi.",
      saveError: "Fatura kaydedilemedi.",
      invoiceNoRequired: "Fatura numarası zorunludur.",
      partyRequired: "Lütfen tedarikçi veya müşteri adı girin.",
      itemsRequired: "Tüm kalemlerde açıklama, miktar ve birim fiyat olmalıdır."
    },
    accounts: {
      title: "Cari Hesaplar",
      totalAccounts: "Toplam Hesap",
      totalReceivable: "Toplam Alacak",
      totalPayable: "Toplam Borç",
      customersVendors: "Müşteriler / Tedarikçiler",
      search: "Hesap ara...",
      allTypes: "Tüm Türler",
      allBalances: "Tüm Bakiyeler",
      balancePositive: "Alacak (pozitif)",
      balanceNegative: "Borç (negatif)",
      balanceZero: "Dengede (sıfır)",
      newAccount: "Yeni Hesap",
      noAccounts: "Henüz hesap yok",
      createFirst: "İlk hesabınızı oluşturun",
      name: "Ad",
      type: "Tür",
      typeCustomer: "Müşteri",
      typeVendor: "Tedarikçi",
      taxId: "Vergi No",
      email: "E-posta",
      phone: "Telefon",
      address: "Adres",
      balance: "Bakiye",
      tags: "Etiketler",
      accountInfo: "Hesap Bilgileri",
      peppolId: "Peppol / e-fatura kimliği",
      currency: "Para birimi",
      creditLimit: "Kredi limiti",
      paymentTermDays: "Ödeme vadesi (gün)",
      daysValue: "{{count}} gün",
      taxClass: "Vergi sınıfı",
      creditExceeded: "Kredi limiti aşıldı",
      taxClasses: { standard: "Standart", reduced: "İndirimli", zero: "Sıfır oranlı", exempt: "Muaf", reverse: "Ters yükleme (reverse charge)" },
      errors: { required: "Zorunlu", peppol: "şema:kimlik biçiminde girin, ör. 0088:5790000435951", nonNegative: "Sıfır veya daha büyük olmalı", days: "0 ile 365 arasında tam gün", enum: "Geçersiz değer" },
      balanceSummary: "Bakiye Özeti",
      receivable: "Alacak",
      payable: "Borç",
      balanced: "Dengede",
      totalDebit: "Toplam Borç",
      totalCredit: "Toplam Alacak",
      transactionHistory: "İşlem Geçmişi",
      noTransactions: "Henüz işlem yok",
      newTransaction: "Yeni İşlem",
      txType: "İşlem Türü",
      txDate: "Tarih",
      txDescription: "Açıklama",
      txDescriptionPlaceholder: "Ödeme, fatura vb.",
      txDebit: "Borç",
      txCredit: "Alacak",
      txAmount: "Tutar",
      txInvoice: "Fatura",
      txInvoicePlaceholder: "Fatura ID (isteğe bağlı)",
      relatedContracts: "İlgili Sözleşmeler",
      noContracts: "İlgili sözleşme yok",
      paymentPlan: "Ödeme Planı",
      noPaymentPlan: "Ödeme planı yok",
      installment: "Taksit",
      actions: "İşlemler",
      notFound: "Hesap bulunamadı.",
      loadError: "Hesap yüklenemedi.",
      deleteTitle: "Hesabı Sil",
      deleteMsg: "\"{{name}}\" hesabını silmek istediğinize emin misiniz?",
      demoDelete: "Demo modunda silme devre dışı."
    },
    approvals: {
      title: "Onaylar",
      pendingApprovals: "Bekleyen Onaylar",
      sentRequests: "Gönderilen Talepler",
      approvedCount: "Onaylandı",
      rejectedCount: "Reddedildi",
      search: "Onay ara…",
      allStatuses: "Tüm Durumlar",
      newRequest: "Yeni Talep",
      tabPending: "Bekleyen Onaylarım",
      tabSent: "Taleplerim",
      noPending: "Bekleyen onay yok.",
      noSent: "Henüz talep göndermediniz.",
      requestTitle: "Başlık",
      type: "Tür",
      typeExpense: "Gider",
      typePayment: "Ödeme",
      typeInvoice: "Fatura",
      requestedBy: "Talep Eden",
      currentApprover: "Mevcut Onaylayan",
      amount: "Tutar",
      currency: "Para Birimi",
      date: "Tarih",
      status: "Durum",
      statusPending: "Beklemede",
      statusInReview: "İnceleniyor",
      statusApproved: "Onaylandı",
      statusRejected: "Reddedildi",
      requestInfo: "Talep Ayrıntıları",
      description: "Açıklama",
      descriptionPlaceholder: "Bu talebin nedenini açıklayın…",
      titlePlaceholder: "örn. Ofis malzemesi alımı",
      titleRequired: "Başlık zorunludur.",
      noApprover: "Onaycı bulunamadı: hesabınız bir üst hesaba bağlı değil. Yöneticinizden bağlantı isteyin.",
      selfApprovalForbidden: "Kendi talebinizi onaylayamaz veya reddedemezsiniz.",
      amountRequired: "Geçerli bir tutar zorunludur.",
      relatedInvoice: "İlgili Fatura",
      invoicePlaceholder: "Fatura ID (isteğe bağlı)",
      thresholdInfo: "Onay Eşikleri",
      tierManager: "Yalnızca Yönetici",
      tierManagerDirector: "Yönetici + Direktör",
      tierManagerDirectorCFO: "Yönetici + Direktör + CFO",
      submit: "Onaya Gönder",
      demoSubmit: "Talep gönderildi (demo modu).",
      submitError: "Talep gönderilemedi.",
      notFound: "Onay talebi bulunamadı.",
      loadError: "Talep yüklenemedi.",
      approvalChain: "Onay Zinciri",
      noChain: "Onay zinciri yapılandırılmamış.",
      awaitingApproval: "Bekleniyor",
      chainProgress: "İlerleme",
      relatedResources: "İlgili Kaynaklar",
      noRelated: "İlgili kaynak yok.",
      actions: "İşlemler",
      approve: "Onayla",
      reject: "Reddet",
      approveTitle: "Talebi Onayla",
      rejectTitle: "Talebi Reddet",
      note: "Not",
      notePlaceholder: "Talep eden için isteğe bağlı not…",
      approvedMsg: "Talep başarıyla onaylandı.",
      rejectedMsg: "Talep reddedildi."
    }
  },
  inventory: {
    title: "Depo / Stok",
    totalProducts: "Toplam Ürün",
    criticalStockCount: "Kritik Stok",
    totalStockValue: "Toplam Stok Değeri",
    categories: "Kategoriler",
    searchPlaceholder: "Ad, SKU, barkod ile ara…",
    allCategories: "Tüm Kategoriler",
    newProduct: "Yeni Ürün",
    noProducts: "Ürün bulunamadı.",
    criticalStock: "Kritik",
    sku: "SKU",
    barcode: "Barkod",
    trade: { title: "Ticari ve lojistik bilgiler", barcodes: "Ek GTIN / barkodlar", barcodesHelp: "Virgülle ayırın. GTIN-8/12/13/14 kontrol hanesi doğrulanır.", gtins: "GTIN / barkodlar", hsCode: "GTİP / HS kodu", originCountry: "Menşe ülkesi (ISO)", dimensions: "Boyutlar (U × G × Y)", lengthCm: "Uzunluk (cm)", widthCm: "Genişlik (cm)", heightCm: "Yükseklik (cm)", netWeightKg: "Net ağırlık (kg)", grossWeightKg: "Brüt ağırlık (kg)", fixErrors: "Lütfen ticari ve lojistik alanları düzeltin.", errors: { gtin: "GTIN kontrol hanesi hatalı", tooLong: "Barkod çok uzun", hsCode: "HS kodu 6-12 haneli olmalı", country: "2 harfli ISO ülke kodu girin, ör. TR", nonNegative: "Sıfır veya daha büyük olmalı", grossBelowNet: "Brüt ağırlık net ağırlıktan küçük olamaz", saveFailed: "Değişiklikler kaydedilemedi." } },
    partyCodes: { title: "Müşteri / tedarikçi ürün kodları", row: "Satır {{n}}", empty: "Henüz iş ortağı kodu yok.", partyType: "İş ortağı türü", partyName: "İş ortağı", code: "İş ortağının kodu", description: "İş ortağının tanımı", customer: "Müşteri", supplier: "Tedarikçi", linked: "Cari karta bağlı", add: "Kod ekle", errors: { required: "İş ortağını ve kodu doldurun", duplicate: "Bu kod iş ortağı için zaten listede", saveFailed: "Kodlar kaydedilemedi." } },
    productName: "Ürün Adı",
    category: "Kategori",
    currentStock: "Stok",
    costPrice: "Maliyet Fiyatı",
    salePrice: "Satış Fiyatı",
    updated: "Güncellendi",
    unit: "Birim",
    description: "Açıklama",
    descriptionPlaceholder: "Ürün açıklaması…",
    serialTracking: "Seri Takibi",
    lotTracking: "Lot Takibi",
    tags: "Etiketler",
    tagsPlaceholder: "örn. ithal, kırılgan",
    currency: "Para Birimi",
    images: "Görseller",
    uploadImages: "Görsel Yükle",
    chooseFiles: "Dosya seçin…",
    productInfo: "Ürün Bilgileri",
    stockLevel: "Stok Seviyesi",
    current: "Güncel",
    technicalDocs: "Teknik Belgeler",
    noDocs: "Teknik belge yok.",
    certificates: "Sertifikalar",
    noCertificates: "Sertifika yok.",
    stockMovements: "Stok Hareketleri",
    noMovements: "Stok hareketi kaydı yok.",
    movementType: "Tür",
    quantity: "Miktar",
    previousStock: "Önceki",
    newStockLevel: "Yeni Seviye",
    note: "Not",
    notePlaceholder: "Stok değişikliği nedeni…",
    date: "Tarih",
    stockIn: "Stok Giriş",
    stockOut: "Stok Çıkış",
    stockInTitle: "Stok Giriş",
    stockOutTitle: "Stok Çıkış",
    stockInSuccess: "Stok girişi kaydedildi.",
    stockOutSuccess: "Stok çıkışı kaydedildi.",
    currentStockLabel: "Mevcut stok",
    insufficientStock: "Miktar mevcut stoku aşıyor!",
    actions: "İşlemler",
    deleteTitle: "Ürünü Sil",
    deleteMsg: "\"{{name}}\" ürününü silmek istediğinize emin misiniz?",
    demoDelete: "Demo modunda silme devre dışı.",
    notFound: "Ürün bulunamadı.",
    loadError: "Ürün yüklenemedi.",
    overview: "Genel Bakış",
    basicInfo: "Temel Bilgiler",
    pricingStock: "Fiyatlandırma ve Stok",
    minStockLevel: "Min. Stok Seviyesi",
    maxStockLevel: "Maks. Stok Seviyesi",
    manualSKU: "Manuel gir",
    autoSKU: "Otomatik oluştur",
    nameRequired: "Ürün adı zorunludur.",
    skuRequired: "SKU zorunludur.",
    documents: "Belgeler",
    technicalDocIds: "Teknik Belge ID'leri",
    docIdsPlaceholder: "doc-1, doc-2",
    docIdsHelp: "Virgülle ayrılmış dosya ID'leri.",
    certificateIds: "Sertifika ID'leri",
    certIdsPlaceholder: "cert-1, cert-2",
    certIdsHelp: "Virgülle ayrılmış dosya ID'leri.",
    summary: "Özet",
    save: "Kaydet",
    demoCreate: "Ürün oluşturuldu (demo modu).",
    createError: "Ürün oluşturulamadı.",
    namePlaceholder: "örn. Dell PowerEdge R750",
    cat_electronics: "Elektronik",
    cat_office: "Ofis Malzemeleri",
    cat_furniture: "Mobilya",
    cat_raw_material: "Hammadde",
    cat_packaging: "Ambalaj",
    cat_spare_parts: "Yedek Parça",
    cat_consumables: "Sarf Malzemesi",
    cat_other: "Diğer"
  },
  movements: {
    title: "Stok Hareketleri",
    search: "Hareket ara...",
    allTypes: "Tüm Türler",
    allProducts: "Tüm Ürünler",
    newEntry: "Yeni Hareket",
    dateFrom: "Başlangıç tarihi",
    dateTo: "Bitiş tarihi",
    clearFilters: "Filtreleri Temizle",
    noMovements: "Stok hareketi bulunamadı.",
    totalIn: "Toplam Giriş",
    totalOut: "Toplam Çıkış",
    transfers: "Transferler",
    adjustments: "Düzeltmeler",
    date: "Tarih",
    product: "Ürün",
    type: "Tür",
    type_in: "Stok Giriş",
    type_out: "Stok Çıkış",
    type_transfer: "Aktarım",
    type_adjustment: "Düzeltme",
    quantity: "Miktar",
    unitCost: "Birim Maliyet",
    reason: "Neden / Not",
    warehouse: "Depo",
    documentNo: "Belge No",
    from: "Kaynak",
    to: "Hedef",
    movementType: "Hareket Türü",
    productSelection: "Ürün ve Miktar",
    productSearchPlaceholder: "Ad, SKU veya barkod ile ara...",
    productRequired: "Lütfen bir ürün seçin.",
    quantityRequired: "Miktar 0'dan büyük olmalıdır.",
    warehouseRequired: "Transferler için kaynak ve hedef depo zorunludur.",
    currentStockLabel: "Mevcut stok",
    lotNumber: "Lot Numarası",
    serialNumbers: "Seri Numaraları",
    serialPlaceholder: "SN-001, SN-002, ...",
    serialHelp: "Virgülle ayrılmış seri numaraları.",
    sourceWarehouse: "Kaynak Depo",
    destWarehouse: "Hedef Depo",
    warehousePlaceholder: "örn. Ana Depo",
    reasonPlaceholder: "Hareket nedeni veya notu...",
    relatedInvoice: "İlgili Fatura ID",
    invoicePlaceholder: "inv-...",
    shipmentDocs: "Sevkiyat Belgeleri",
    addDoc: "Yeni Ekle",
    noExistingDocs: "Sevkiyat belgesi yok.",
    newShipmentDoc: "Yeni Sevkiyat Belgesi",
    chooseFile: "Dosya seçin...",
    summary: "Özet",
    estimatedStock: "Tahmini Yeni Stok",
    totalCost: "Toplam Maliyet",
    save: "Hareketi Kaydet",
    demoSuccess: "Hareket kaydedildi (demo modu).",
    submitError: "Hareket kaydedilemedi."
  },
  shipments: {
    title: "Sevkiyat Belgeleri",
    search: "Belge ara...",
    allTypes: "Tüm Türler",
    totalDocs: "Toplam Belge",
    waybills: "İrsaliyeler",
    packingLists: "Paketleme Listeleri",
    deliveryNotes: "Teslimat Notları",
    noDocs: "Sevkiyat belgesi bulunamadı.",
    newDoc: "Yeni Belge",
    documentNo: "Belge No",
    docType: "Belge Türü",
    type_waybill: "İrsaliye",
    type_packingList: "Paketleme Listesi",
    type_deliveryNote: "Teslimat Notu",
    vendor: "Tedarikçi / Taşıyıcı",
    vendorPlaceholder: "örn. DHL, UPS...",
    date: "Tarih",
    relatedMovements: "İlgili Hareketler",
    movements: "hareket",
    file: "Dosya",
    view: "Görüntüle",
    noFile: "Dosya yok",
    created: "Oluşturulma",
    create: "Oluştur",
    docNoRequired: "Belge numarası zorunludur.",
    demoCreate: "Sevkiyat belgesi oluşturuldu (demo modu).",
    createError: "Belge oluşturulamadı."
  },
  purchaseRequests: {
    title: "Satın Alma Talepleri",
    search: "Talep ara...",
    allStatuses: "Tüm Durumlar",
    total: "Toplam Talep",
    pending: "Beklemede",
    ordered: "Sipariş Verildi",
    received: "Teslim Alındı",
    noRequests: "Satın alma talebi bulunamadı. Kritik ürünleri tespit etmek için stok taraması çalıştırın.",
    scanStock: "Stok Seviyelerini Tara",
    noAlerts: "Tüm stok seviyeleri sağlıklı — kritik ürün tespit edilmedi.",
    scanResult: "{{count}} kritik ürün tespit edildi, {{created}} satın alma talebi oluşturuldu.",
    scanError: "Stok seviyeleri taranamadı.",
    product: "Ürün",
    currentStock: "Mevcut Stok",
    minLevel: "Min. Seviye",
    suggestedQty: "Önerilen Miktar",
    estCost: "Tahmini Maliyet",
    status: "Durum",
    created: "Oluşturulma",
    status_auto_generated: "Otomatik Oluşturuldu",
    status_submitted: "Gönderildi",
    status_ordered: "Sipariş Verildi",
    status_received: "Teslim Alındı",
    actionSubmit: "Gönder",
    actionOrder: "Sipariş Verildi İşaretle",
    actionReceive: "Teslim Al",
    completed: "Tamamlandı",
    receiveTitle: "Stok Teslim Al",
    newStock: "Yeni Stok",
    receivedQty: "Teslim Alınan Miktar",
    receiveHelp: "Gerçek teslim alınan miktarı girin. Otomatik olarak stok girişi hareketi oluşturulacaktır.",
    confirmReceive: "Teslim Almayı Onayla",
    receiveSuccess: "{{product}} ürününden {{qty}} birim teslim alındı ve stok güncellendi.",
    receiveError: "Stok teslim alınamadı."
  },
  criticalStock: {
    title: "Kritik Stok",
    products: "ürün",
    noCritical: "Tüm stok seviyeleri uygun",
    viewAll: "Talepleri Görüntüle"
  },
  serialTracking: {
    title: "Seri Numarası Takibi",
    total: "Toplam Seri",
    inStock: "Stokta",
    sold: "Satıldı",
    warranty: "Garantide",
    returned: "İade",
    scrapped: "Hurda",
    search: "Seri no ara…",
    allStatuses: "Tüm Durumlar",
    status_in_stock: "Stokta",
    status_sold: "Satıldı",
    status_warranty: "Garantide",
    status_returned: "İade",
    status_scrapped: "Hurda",
    serialNo: "Seri Numarası",
    status: "Durum",
    purchaseDate: "Satın Alma Tarihi",
    warrantyExpiry: "Garanti Bitişi",
    customer: "Müşteri",
    history: "Geçmiş",
    events: "olay",
    addSerial: "Seri Ekle",
    noSerials: "Seri numarası bulunamadı.",
    serialRequired: "Seri numarası zorunludur.",
    demoCreate: "Seri numarası oluşturuldu (demo modu).",
    createError: "Seri numarası oluşturulamadı.",
    create: "Oluştur",
    movementHistory: "Hareket Geçmişi",
    noHistory: "Henüz geçmiş yok.",
    relatedFiles: "İlgili Dosyalar",
    warrantyExpired: "Süresi Dolmuş",
    daysLeft: "gün kaldı",
    customerPlaceholder: "Müşteri adı / şirket",
    tab: "Seri Numaraları",
    viewAll: "Tüm Serileri Görüntüle"
  },
  lotTracking: {
    title: "Lot / Parti Takibi",
    totalLots: "Toplam Lot",
    active: "Aktif",
    expiringSoon: "Yakında Süresi Dolacak",
    critical: "Kritik",
    search: "Lot no ara…",
    allStatuses: "Tüm Durumlar",
    status_active: "Aktif",
    status_expired: "Süresi Dolmuş",
    status_recalled: "Geri Çağırıldı",
    lotNumber: "Lot Numarası",
    status: "Durum",
    quantity: "Miktar",
    manufacturingDate: "Üretim Tarihi",
    expiryDate: "Son Kullanma Tarihi",
    supplier: "Tedarikçi",
    qualityCert: "Kalite Sert.",
    viewCert: "Sertifikayı Görüntüle",
    addLot: "Lot Ekle",
    noLots: "Lot bulunamadı.",
    lotRequired: "Lot numarası zorunludur.",
    demoCreate: "Lot oluşturuldu (demo modu).",
    createError: "Lot oluşturulamadı.",
    create: "Oluştur",
    expired: "Süresi Dolmuş",
    daysLeft: "gün kaldı",
    criticalAlert: "Kritik",
    lotsExpiredOrCritical: "lot süresi dolmuş veya 7 gün içinde dolacak",
    warningAlert: "Uyarı",
    lotsExpiring30: "lot 30 gün içinde süresi dolacak",
    supplierPlaceholder: "Tedarikçi adı",
    qualityCertFileId: "Kalite Sert. Dosya ID",
    certIdPlaceholder: "Belgelerden dosya ID",
    tab: "Lotlar",
    viewAll: "Tüm Lotları Görüntüle"
  },
  session: {
    expiringTitle: "Oturumunuz sona ermek üzere",
    expiringBody: "Hareketsizlik nedeniyle {{seconds}} saniye içinde oturumunuz kapatılacak.",
    stay: "Oturumda kal",
    signOutNow: "Çıkış yap",
    timedOut: "Uzun süre işlem yapılmadığı için oturumunuz kapatıldı. Lütfen tekrar giriş yapın.",
    disabled: "Hesabınız pasife alınmış. Yöneticinizle iletişime geçin.",
    sessionLimit: "Eşzamanlı oturum sınırına ulaşıldı. Başka bir cihazdaki oturumu kapatıp tekrar deneyin.",
    revoked: "Oturumunuz başka bir yerden sonlandırıldı."
  },
  exchangeRates: {
    title: "Kur Tablosu",
    subtitle: "{{base}} karşılığı elle girilen kurlar; fatura, kur tarihindeki kuru kullanır.",
    formTitle: "Kur ekle veya güncelle",
    listTitle: "Kurlar",
    date: "Tarih",
    currency: "Döviz",
    rateType: "Kur tipi",
    source: "Kaynak",
    buy: "Alış",
    sell: "Satış",
    average: "Ortalama",
    note: "Not",
    averageHint: "Ortalama boş bırakılırsa alış/satış ortalaması kullanılır. Aynı tarih, döviz ve tip yeniden kaydedilirse kur güncellenir.",
    allCurrencies: "Tüm dövizler",
    empty: "Henüz kur girilmedi",
    saved: "Kur kaydedildi.",
    loadError: "Kurlar yüklenemedi.",
    saveError: "Kur kaydedilemedi.",
    confirmDelete: "{{date}} tarihli {{currency}} kuru silinsin mi?",
    types: { forex: "Döviz", banknote: "Efektif", custom: "Özel" },
    sides: { buy: "Alış", sell: "Satış", average: "Ortalama" },
    errors: { date: "Geçerli bir tarih girin", currency: "Döviz seçin", sameAsBase: "Ana para biriminden farklı olmalı", enum: "Geçersiz değer", source: "Kaynak girin (en fazla 40 karakter)", positive: "Sıfırdan büyük olmalı", sellBelowBuy: "Satış kuru alıştan düşük olamaz", tooLong: "Çok uzun" },
    invoice: { title: "Döviz kuru", rateDate: "Kur tarihi", side: "Kullanılan kur", found: "{{currency}}/{{base}} {{value}} ({{source}}, {{date}})", fallback: "{{requested}} için kur yok; önceki en yakın kur ({{date}}) kullanılıyor.", missing: "{{date}} veya öncesine ait {{currency}} kuru yok. Önce kur tablosuna ekleyin.", baseTotal: "{{base}} karşılığı toplam" }
  },
  privacyRequests: {
    title: "Kişisel veri başvuruları (KVKK / GDPR)",
    subtitle: "Kişisel verileriniz üzerindeki haklarınızı kullanın; başvurular yasal süre içinde yanıtlanır.",
    newTitle: "Yeni başvuru",
    type: "Başvuru türü",
    regime: "Uygulanacak mevzuat",
    details: "Açıklama",
    detailsPlaceholder: "Hangi veriler ve ne yapılmasını istediğiniz (ör. düzeltilecek alan, dışa aktarım biçimi).",
    submit: "Başvuruyu gönder",
    submitted: "{{no}} numaralı başvurunuz alındı. En geç {{days}} gün içinde yanıtlanacak.",
    submitError: "Başvuru gönderilemedi.",
    saveError: "Değişiklik kaydedilemedi.",
    deadlineNote: "Yasal süre: başvurunun alınmasından itibaren {{days}} gün (KVKK md. 13, GDPR md. 12). GDPR kapsamında gerekçeyle bir kez {{extra}} gün uzatılabilir.",
    mineTitle: "Başvurularım",
    emptyMine: "Henüz başvurunuz yok.",
    queueTitle: "Başvuru kuyruğu",
    emptyQueue: "İşlenecek başvuru yok.",
    openCount: "{{count}} açık",
    overdueCount: "{{count}} süresi geçmiş",
    no: "No",
    statusLabel: "Durum",
    received: "Alındı",
    deadline: "Son tarih",
    requester: "Başvuran",
    withdraw: "Geri çek",
    confirmWithdraw: "Bu başvuru geri çekilsin mi?",
    overdue: "Süre geçti ({{date}})",
    daysLeft: "{{count}} gün kaldı ({{date}})",
    daysLeft_one: "1 gün kaldı ({{date}})",
    types: {
      access: "Erişim (bilgi talebi)",
      rectification: "Düzeltme",
      erasure: "Silme / anonimleştirme",
      portability: "Veri taşınabilirliği"
    },
    typeDesc: {
      access: "Verilerinizin işlenip işlenmediğini, nasıl işlendiğini öğrenin ve bir kopyasını alın.",
      rectification: "Eksik veya yanlış verilerin düzeltilmesini isteyin.",
      erasure: "Artık gerekli olmayan verilerin silinmesini veya anonimleştirilmesini isteyin.",
      portability: "Verilerinizi makinece okunabilir biçimde alın."
    },
    regimes: {
      kvkk: "KVKK (Türkiye)",
      gdpr: "GDPR (AB / AEA)"
    },
    status: {
      received: "Alındı",
      in_review: "İnceleniyor",
      completed: "Tamamlandı",
      rejected: "Reddedildi",
      withdrawn: "Geri çekildi"
    },
    errors: {
      type: "Bir başvuru türü seçin.",
      tooShort: "Lütfen başvurunuzu açıklayın (en az 10 karakter).",
      tooLong: "Çok uzun."
    },
    handle: {
      open: "İşle",
      note: "Başvurana yanıt",
      noteHint: "Başvurana gösterilir. Ret kararının gerekçesi yazılmalıdır.",
      reasonRequired: "Ret kararının gerekçesi yazılmalıdır.",
      extend: "Süreyi {{days}} gün uzat (GDPR md. 12/3)",
      extensionReason: "Uzatma gerekçesi",
      extensionReasonRequired: "Uzatma gerekçesini yazın."
    }
  },
  auditLog: {
    title: "Denetim Kaydı",
    scopeAll: "Platformdaki tüm kayıtlar (kullanıcı, aksiyon, varlık, önceki/yeni değer).",
    scopeMine: "Sizin ve yönettiğiniz kullanıcıların kayıtları.",
    from: "Başlangıç",
    to: "Bitiş",
    user: "Kullanıcı",
    allUsers: "Tüm kullanıcılar",
    action: "Aksiyon",
    allActions: "Tüm aksiyonlar",
    entityType: "Varlık türü",
    entity: "Varlık",
    apply: "Uygula",
    search: "Sonuçlarda ara…",
    count: "{{count}} kayıt",
    exportCsv: "CSV indir",
    exportJsonl: "JSON Lines indir (SIEM)",
    exportCef: "CEF indir (SIEM)",
    exportMenu: "Dışa aktar",
    emptyTitle: "Kayıt bulunamadı",
    emptyBody: "Seçilen filtrelere uyan denetim kaydı yok.",
    when: "Zaman",
    previous: "Önceki",
    next: "Yeni",
    loadMore: "Daha fazla yükle",
    loadFailed: "Denetim kayıtları yüklenemedi."
  },
  cookies: {
    bannerText: "Oturum ve güvenlik için zorunlu çerezler kullanıyoruz. İzin verirseniz, ürünü geliştirmek için anonim kullanım istatistikleri (Google Analytics) de toplarız.",
    policyLink: "Gizlilik politikası",
    customize: "Tercihler",
    necessaryOnly: "Yalnızca zorunlu",
    acceptAll: "Tümünü kabul et",
    settingsTitle: "Çerez tercihleri",
    necessaryTitle: "Zorunlu çerezler",
    necessaryDesc: "Giriş, oturum, güvenlik ve dil tercihi için gereklidir; kapatılamaz.",
    analyticsTitle: "Analitik çerezler",
    analyticsDesc: "Sayfa görüntüleme ve kullanım istatistikleri (Google Analytics / Firebase). İzin vermediğiniz sürece yüklenmez; istediğiniz zaman geri alabilirsiniz.",
    save: "Kaydet",
    settingsLink: "Çerez tercihleri"
  },
  reauth: {
    title: "Kimliğinizi doğrulayın",
    body: "Bu işlem hassas olduğu için şifrenizi yeniden girmeniz gerekiyor. Doğrulama birkaç dakika geçerlidir.",
    password: "Şifre",
    confirm: "Doğrula",
    wrongPassword: "Şifre hatalı. Lütfen tekrar deneyin."
  },
  sessions: {
    countHint: "Son 3 dakikada aktif kullanıcı ({{sessions}} oturum). Aynı kişinin birden fazla cihazı tek sayılır.",
    revoke: "Sonlandır",
    confirmRevoke: "{{user}} kullanıcısının bu oturumu sonlandırılsın mı?",
    thisDevice: "Bu cihaz",
    you: "Siz",
    policyTitle: "Oturum politikası",
    idleMinutes: "Hareketsizlikte oturumu kapat (dakika)",
    sessionLimit: "Eşzamanlı kullanıcı sınırı",
    rangeError: "{{min}} ile {{max}} arasında bir tam sayı girin.",
    policyHint: "Şirketinizdeki herkes için web ve mobilde geçerlidir. Yeni süre hemen uygulanır; kullanıcı sınırı bir sonraki girişte kontrol edilir.",
    policyReadOnly: "Şirket yöneticiniz tarafından belirlenir.",
    policySaved: "Oturum politikası kaydedildi.",
    policyError: "Oturum politikası kaydedilemedi."
  },
  dataTransfer: {
    menu: "İçe / dışa aktar",
    exportXlsx: "Excel (XLSX) olarak indir",
    exportCsv: "CSV olarak indir",
    import: "Dosyadan içe aktar…",
    importTitle: "{{entity}} içe aktar",
    importHint: "CSV veya XLSX yükleyin; ilk satır sütun başlıkları olmalı. En fazla {{max}} satır. Önce önizleme gösterilir, hiçbir şey onaysız kaydedilmez.",
    chooseFile: "Dosya seç",
    template: "sablon",
    downloadTemplate: "Şablonu indir",
    missingColumns: "Zorunlu sütunlar bulunamadı: {{columns}}",
    tooManyRows: "Dosyada {{count}} satır var; tek seferde en fazla {{max}} satır içe aktarılabilir.",
    summary: "{{valid}} satır hazır, {{invalid}} satır hatalı (hatalı satırlar atlanır).",
    line: "Satır {{line}}",
    moreErrors: "…ve {{count}} hatalı satır daha",
    importCount: "{{count}} kaydı içe aktar",
    done: "{{created}} kayıt oluşturuldu, {{failed}} kayıt başarısız.",
    fields: {
      sku: "Stok kodu",
      name: "Ad",
      barcode: "Barkod",
      category: "Kategori",
      unit: "Birim",
      currentStock: "Mevcut stok",
      minStockLevel: "Min. stok",
      maxStockLevel: "Maks. stok",
      costPrice: "Maliyet fiyatı",
      salePrice: "Satış fiyatı",
      currency: "Para birimi",
      status: "Durum",
      description: "Açıklama",
      type: "Tür",
      taxId: "Vergi no",
      email: "E-posta",
      phone: "Telefon",
      address: "Adres",
      balance: "Bakiye",
      invoiceNo: "Fatura no",
      vendor: "Tedarikçi",
      customer: "Müşteri",
      issueDate: "Düzenleme tarihi",
      dueDate: "Vade tarihi",
      amount: "Tutar (KDV hariç)",
      taxRate: "KDV oranı (%)",
      totalAmount: "Genel toplam",
      date: "Tarih",
      productName: "Ürün adı",
      quantity: "Miktar",
      unitCost: "Birim maliyet",
      reason: "Neden",
      lotNumber: "Lot no",
      peppolId: "Peppol kimliği",
      creditLimit: "Kredi limiti",
      paymentTermDays: "Ödeme vadesi (gün)",
      taxClass: "Vergi sınıfı",
      barcodes: "Ek GTIN'ler",
      hsCode: "GTİP / HS kodu",
      originCountry: "Menşe ülkesi",
      lengthCm: "Uzunluk (cm)",
      widthCm: "Genişlik (cm)",
      heightCm: "Yükseklik (cm)",
      netWeightKg: "Net ağırlık (kg)",
      grossWeightKg: "Brüt ağırlık (kg)"
    },
    entities: {
      products: "Urunler",
      accounts: "Cariler",
      invoices: "Faturalar",
      stockMovements: "Stok-hareketleri"
    },
    rowErrors: {
      required: "{{field}} zorunlu",
      number: "{{field}} sayı olmalı",
      date: "{{field}} geçerli bir tarih değil (GG.AA.YYYY veya YYYY-AA-GG)",
      email: "{{field}} geçerli bir e-posta değil",
      enum: "{{field}} değeri tanınmadı",
      duplicate: "{{field}} zaten var",
      party: "Müşteri veya tedarikçi gerekli",
      positive: "{{field}} sıfırdan büyük olmalı",
      unknownProduct: "Bu stok koduyla ürün bulunamadı",
      peppol: "{{field}} 0088:5790000435951 biçiminde olmalı",
      nonNegative: "{{field}} negatif olamaz",
      gtin: "{{field}} GTIN kontrol hanesi hatalı",
      hsCode: "{{field}} 6-12 haneli olmalı",
      country: "{{field}} 2 harfli ISO kodu olmalı"
    },
    errors: {
      tooLarge: "Dosya 5 MB sınırını aşıyor.",
      unsupported: "Yalnızca .csv ve .xlsx dosyaları desteklenir.",
      invalid: "Dosya okunamadı. Biçimini kontrol edin.",
      browser: "Bu tarayıcı sıkıştırılmış XLSX okuyamıyor; CSV kullanın veya tarayıcıyı güncelleyin.",
      exportFailed: "Dışa aktarma başarısız oldu."
    }
  },
  scmUi: {
    openProductBom: "Ürünü / ürün ağacını aç",
    qualityInspections: "Kalite muayeneleri",
    packFinishedGoods: "Mamulleri paketle",
    consumeMaterials: "Malzeme tüket",
    postOutput: "Çıktıyı kaydet",
    lots: "Lotlar",
    serials2: "Seri numaraları",
    addPallet: "Palete ekle",
    ship2: "Sevk et",
    close: "Kapat",
    receive: "Teslim al",
    deactivate: "Pasifleştir",
    confirm: "Onayla",
    createMo: "Üretim emri oluştur",
    centralReferenceCatalogsSupplyChainDocument: "Tedarik zinciri ve belge işlemleri için merkezi referans katalogları.",
    addItem: "Kayıt ekle",
    foundationDirectoryUsersScmPlatformRoles: "Kullanıcıların ve tedarik zinciri/platform rollerinin temel dizini.",
    packBox: "Kutu paketle",
    reverse: "Ters kayıt",
    productRequired: "Ürün zorunlu",
    exportOrders: "İhracat Siparişleri",
    exportOrdersCommercialDocuments: "İhracat siparişleri ve ticari belgeler",
    orders: "Siparişler",
    shipments: "Sevkiyatlar",
    customs: "Gümrük",
    newExport: "Yeni ihracat",
    noExportOrders: "İhracat siparişi yok",
    code: "Kod",
    customer: "Müşteri",
    destination: "Varış yeri",
    incoterm: "Teslim şekli",
    total: "Toplam",
    status: "Durum",
    open: "Aç",
    exportDocuments: "İhracat belgeleri",
    addDoc: "Belge ekle",
    noDocumentsYet: "Henüz belge yok",
    type: "Tür",
    no: "No",
    newExportOrder: "Yeni ihracat siparişi",
    destinationCountry: "Varış ülkesi",
    currency: "Para birimi",
    forwarder: "Nakliye komisyoncusu",
    product: "Ürün",
    select: "Seçin…",
    qty: "Miktar",
    unitPrice: "Birim fiyat",
    hsCode: "GTİP kodu",
    cancel: "İptal",
    create: "Oluştur",
    addExportDocument: "İhracat belgesi ekle",
    documentNo: "Belge no",
    autoEmpty: "Boşsa otomatik",
    issue: "Düzenle",
    invalidTransition: "Geçersiz durum geçişi",
    manufacturingOrderNotFound: "Üretim emri bulunamadı",
    execution: "Yürütme",
    workOrders: "İş emirleri",
    noWorkOrdersYet: "Henüz iş emri yok",
    releaseMoGenerateDefaultSteps: "Varsayılan adımları oluşturmak için üretim emrini serbest bırakın",
    name: "Ad",
    start: "Başlat",
    done: "Tamamla",
    extraStepName: "Ek adım adı",
    add: "Ekle",
    bomConsumption: "Ürün ağacı / tüketim",
    noBomLinesAddActiveBom: "Ürün ağacı satırı yok. Önce ürüne aktif bir ürün ağacı ekleyin.",
    component: "Bileşen",
    per: "Birim başına",
    required: "Gerekli",
    consumed: "Tüketilen",
    productionOutput: "Üretim çıktısı",
    quantity: "Miktar",
    lotBatch: "Lot / parti",
    serialNumbers: "Seri numaraları",
    commaNewlineSeparated: "Virgül veya yeni satırla ayırın",
    serials: "Seri no:",
    internationalShipments: "Uluslararası Sevkiyatlar",
    oceanAirRoadExportMoves: "Deniz / hava / kara ihracat taşımaları",
    exportOrders2: "İhracat siparişleri",
    containers: "Konteynerler",
    newShipment: "Yeni sevkiyat",
    noShipments: "Sevkiyat yok",
    export: "İhracat",
    route: "Güzergâh",
    mode: "Taşıma şekli",
    container: "Konteyner",
    newInternationalShipment: "Yeni uluslararası sevkiyat",
    exportOrder: "İhracat siparişi",
    origin: "Çıkış yeri",
    sea: "deniz",
    air: "hava",
    road: "kara",
    rail: "demiryolu",
    attachContainer: "Konteyner bağla",
    attach: "Bağla",
    customerProductRequired: "Müşteri ve ürün zorunlu",
    confirmOrderFirst: "Önce siparişi onaylayın",
    delivered: "Teslim edildi",
    salesOrders: "Satış Siparişleri",
    customers: "Müşteriler",
    fulfillment: "Sipariş karşılama",
    newSo: "Yeni satış siparişi",
    noSalesOrders: "Satış siparişi yok",
    warehouse: "Depo",
    reserved: "Rezerve",
    picked: "Toplandı",
    packed: "Paketlendi",
    price: "Fiyat",
    newSalesOrder: "Yeni satış siparişi",
    ship: "Teslimat adresi",
    lastMileDelivery: "Son kilometre teslimatı",
    carrier: "Taşıyıcı",
    trackingNo: "Takip no",
    confirmDelivery: "Teslimatı onayla",
    titleRequired: "Başlık zorunlu",
    nonConformanceCapa: "Uygunsuzluk ve DÖF",
    ncrLifecycleCorrectiveActions: "Uygunsuzluk yaşam döngüsü ve düzeltici faaliyetler",
    inspections: "Muayeneler",
    newNcr: "Yeni uygunsuzluk",
    noNonConformances: "Uygunsuzluk yok",
    title: "Başlık",
    severity: "Önem derecesi",
    source: "Kaynak",
    correctiveActions: "Düzeltici faaliyetler",
    addCapa: "DÖF ekle",
    noCapaYet: "Henüz DÖF yok",
    action: "Faaliyet",
    owner: "Sorumlu",
    description: "Açıklama",
    newCorrectiveAction: "Yeni düzeltici faaliyet",
    dueDate: "Bitiş tarihi",
    save: "Kaydet",
    selectPalletFirst: "Önce bir palet seçin",
    alreadyPallet: "Zaten bir palette",
    packagesPallets: "Paketler ve Paletler",
    boxCartonPackingPalletBuild: "Kutu / koli paketleme ve palet oluşturma",
    packages: "Paketler",
    newPackage: "Yeni paket",
    noPackages: "Paket yok",
    pallets: "Paletler",
    newPallet: "Yeni palet",
    noPallets: "Palet yok",
    pkgs: "Paket",
    lot: "Lot",
    label: "Etiket",
    optionalLabel: "İsteğe bağlı etiket",
    warrantyRegistered: "Garanti kaydedildi",
    claimOpened: "Talep açıldı",
    warrantyExpired: "Garanti süresi dolmuş",
    serviceOrderCreated: "Servis emri oluşturuldu",
    warranty: "Garanti",
    registrationsClaims: "Kayıtlar ve talepler",
    warranties: "Garantiler",
    service: "Servis",
    register: "Kaydet",
    noWarranties: "Garanti yok",
    ends: "Bitiş",
    claims: "Talepler",
    newClaim: "Yeni talep",
    noClaims: "Talep yok",
    registerWarranty: "Garanti kaydet",
    serial: "Seri no",
    months: "Ay",
    startDate: "Başlangıç tarihi",
    newWarrantyClaim: "Yeni garanti talebi",
    openClaim: "Talep aç",
    supplierProductRequired: "Tedarikçi ve ürün zorunlu",
    purchaseOrders: "Satın Alma Siparişleri",
    poLifecycleStatusHistory: "Durum geçmişiyle satın alma siparişi yaşam döngüsü",
    newPo: "Yeni sipariş",
    noPurchaseOrders: "Satın alma siparişi yok",
    supplier: "Tedarikçi",
    details: "Ayrıntılar",
    newPurchaseOrder: "Yeni satın alma siparişi",
    notes: "Notlar",
    nameRequired: "Ad zorunlu",
    suppliers: "Tedarikçiler",
    procurementSupplierMasterData: "Satın alma tedarikçi ana verileri",
    search: "Ara…",
    addSupplier: "Tedarikçi ekle",
    noSuppliers: "Tedarikçi yok",
    addYourFirstSupplier: "İlk tedarikçinizi ekleyin.",
    country: "Ülke",
    terms: "Koşullar",
    newSupplier: "Yeni tedarikçi",
    paymentTerms: "Ödeme koşulları",
    incoterms: "Teslim şekilleri",
    email: "E-posta",
    phone: "Telefon",
    noData: "Veri yok",
    count: "Adet",
    scmReports: "Tedarik Zinciri Raporları",
    kpisPipelinesRecentAuditActivity: "Performans göstergeleri, süreç hatları, son denetim etkinliği",
    refresh: "Yenile",
    salesOrders2: "Satış siparişleri",
    purchaseOrders2: "Satın alma siparişleri",
    manufacturing: "Üretim",
    pendingApprovals: "Bekleyen onaylar",
    returns: "İadeler",
    openRmas: "Açık iade yetkileri",
    lowStockSkus: "Stoku azalan ürünler",
    salesPipeline: "Satış süreci",
    procurementPipeline: "Satın alma süreci",
    manufacturingPipeline: "Üretim süreci",
    exportPipeline: "İhracat süreci",
    recentAuditActivity: "Son denetim etkinliği",
    noAuditEntries: "Denetim kaydı yok",
    entity: "Kayıt",
    user: "Kullanıcı",
    generated: "Oluşturulma",
    selectProduct: "Bir ürün seçin",
    invalidStatusTransition: "Geçersiz durum geçişi",
    rfqs: "Teklif Talepleri",
    requestQuotation: "Teklif talebi",
    rfqList: "Teklif talepleri listesi",
    newRfq: "Yeni teklif talebi",
    noRfqs: "Teklif talebi yok",
    items: "Kalemler",
    history: "Geçmiş",
    send: "Gönder",
    addQuote: "Teklif ekle",
    createPo: "Sipariş oluştur",
    supplierQuotation: "Tedarikçi teklifi",
    saveQuotation: "Teklifi kaydet",
    financeIntegration: "Finans Entegrasyonu",
    createDraftInvoicesFromSalesPurchase: "Satış / satın alma siparişlerinden taslak fatura oluşturun",
    links: "Bağlantılar",
    invoices: "Faturalar",
    noFinanceLinksYet: "Henüz finans bağlantısı yok",
    invoice: "Fatura",
    amount: "Tutar",
    noEligibleSalesOrders: "Uygun satış siparişi yok",
    linked: "bağlandı",
    createInvoice: "Fatura oluştur",
    noEligiblePurchaseOrders: "Uygun satın alma siparişi yok",
    nameRequired2: "Ad zorunlu",
    warehouses: "Depolar",
    warehouseMasterLocations: "Depo ana verileri ve lokasyonlar",
    addWarehouse: "Depo ekle",
    noWarehouses: "Depo yok",
    location: "Konum",
    default: "varsayılan",
    locations: "Lokasyonlar",
    newWarehouse: "Yeni depo",
    finishedGoods: "Mamul",
    rawMaterial: "Hammadde",
    overseas3pl: "Yurt dışı / 3PL",
    qualityHold: "Kalite karantinası",
    city: "Şehir",
    declarationsDutiesTaxesBrokers: "Beyannameler, gümrük vergileri, vergiler, müşavirler",
    declarations: "Beyannameler",
    newDeclaration: "Yeni beyanname",
    noCustomsDeclarations: "Gümrük beyannamesi yok",
    declaration: "Beyanname",
    shipment: "Sevkiyat",
    duties: "Gümrük vergileri",
    newCustomsDeclaration: "Yeni gümrük beyannamesi",
    declarationNo: "Beyanname no",
    hsCodes: "GTİP kodları",
    commaNewlineDefaultsFromExportLines: "Virgül veya yeni satır; varsayılan olarak ihracat satırlarından alınır",
    broker: "Gümrük müşaviri",
    taxes: "Vergiler",
    reservationsPicksPacksDispatchesDeliveries: "Rezervasyonlar, toplama, paketleme, sevk ve teslimatlar",
    reservations: "Rezervasyonlar",
    pickLists: "Toplama listeleri",
    packs: "Paketler",
    dispatches: "Sevkler",
    deliveries: "Teslimatlar",
    customerMasterSalesOrders: "Satış siparişleri için müşteri ana verileri",
    priceLists: "Fiyat listeleri",
    noCustomers: "Müşteri yok",
    contact: "İletişim",
    newCustomer: "Yeni müşteri",
    billingAddress: "Fatura adresi",
    defaultPriceList: "Varsayılan fiyat listesi",
    notificationSent: "Bildirim gönderildi",
    notificationEngine: "Bildirim Motoru",
    myInbox: "Gelen kutum",
    classicInbox: "Klasik gelen kutusu",
    markAllRead: "Tümünü okundu işaretle",
    noNotifications: "Bildirim yok",
    message: "Mesaj",
    unread: "okunmadı",
    recentEngineEvents: "Son motor olayları",
    noEventsLoggedYet: "Henüz kayıtlı olay yok",
    sendNotification: "Bildirim gönder",
    targetUserId: "Hedef kullanıcı kimliği",
    defaultsYou: "Varsayılan: siz",
    approvalSubmitted: "Onaya gönderildi",
    approvalEngine: "Onay Motoru",
    workflows: "İş akışları",
    legacyApprovals: "Eski onaylar",
    submit: "Gönder",
    noApprovalRequests: "Onay talebi yok",
    requester: "Talep eden",
    approve: "Onayla",
    reject: "Reddet",
    submitApproval: "Onaya gönder",
    entityType: "Kayıt türü",
    document: "Belge",
    productionPlanning: "Üretim Planlama",
    planFinishedGoodsQuantitiesThenRelease: "Mamul miktarlarını planlayın, ardından üretim emirlerini serbest bırakın",
    plans: "Planlar",
    newPlan: "Yeni plan",
    noProductionPlans: "Üretim planı yok",
    window: "Dönem",
    newProductionPlan: "Yeni üretim planı",
    plannedQuantity: "Planlanan miktar",
    end: "Bitiş",
    rmWarehouse: "Hammadde deposu",
    fgWarehouse: "Mamul deposu",
    customerRequired: "Müşteri zorunlu",
    serviceOrders: "Servis Emirleri",
    repairServiceTicketsLinkedRmaWarranty: "İade yetkisi veya garantiye bağlı onarım / servis kayıtları",
    newService: "Yeni servis",
    noServiceOrders: "Servis emri yok",
    assignee: "Atanan",
    newServiceOrder: "Yeni servis emri",
    schedule: "Planlanan tarih",
    manufacturingOrders: "Üretim Emirleri",
    releaseExecuteConsumeMaterialsPostFinished: "Serbest bırak, yürüt, malzeme tüket, mamul kaydet",
    newMo: "Yeni üretim emri",
    noManufacturingOrders: "Üretim emri yok",
    planned: "Planlanan",
    completed: "Tamamlanan",
    noBom: "ürün ağacı yok",
    newManufacturingOrder: "Yeni üretim emri",
    finishedProduct: "Mamul ürün",
    activeBomSnapshottedCreate: "Aktif ürün ağacı oluşturma anında kopyalanır",
    plannedQty: "Planlanan miktar",
    inspectionSubmitted: "Muayene gönderildi",
    approved: "Onaylandı",
    ncrCreated: "Uygunsuzluk kaydı oluşturuldu",
    recordApproveQualityInspections: "Kalite muayenelerini kaydedin ve onaylayın",
    newInspection: "Yeni muayene",
    noInspectionsYet: "Henüz muayene yok",
    plan: "Plan",
    result: "Sonuç",
    openNcr: "Uygunsuzluk aç",
    qualityPlan: "Kalite planı",
    manufacturingOrder: "Üretim emri",
    containerLoadStatusShipmentLink: "Konteyner yükleme durumu ve sevkiyat bağlantısı",
    newContainer: "Yeni konteyner",
    noContainers: "Konteyner yok",
    containerNo: "Konteyner no",
    seal: "Mühür",
    sealNo: "Mühür no",
    overseasWarehouses: "Yurt Dışı Depolar",
    overseas3plDistributionCenters: "Yurt dışı / 3PL / dağıtım merkezleri",
    overseas: "Yurt dışı",
    allWarehouses: "Tüm depolar",
    noOverseasWarehouses: "Yurt dışı depo yok",
    newOverseasWarehouse: "Yeni yurt dışı depo",
    selectPoWarehouse: "Sipariş ve depo seçin",
    goodsReceiptPosted: "Mal kabul kaydedildi",
    goodsReceipt: "Mal Kabul",
    receiveAgainstPurchaseOrdersIntoWarehouse: "Satın alma siparişlerine karşı depoya mal kabul",
    goodsReceipts: "Mal kabuller",
    newReceipt: "Yeni mal kabul",
    noGoodsReceiptsYet: "Henüz mal kabul yok",
    lines: "Satırlar",
    receiveFromPo: "Siparişten teslim al",
    purchaseOrder: "Satın alma siparişi",
    ordered: "Sipariş edilen",
    alreadyRecv: "Teslim alınan",
    receiveNow: "Şimdi alınacak",
    postReceipt: "Mal kabulü kaydet",
    qualityPlans: "Kalite Planları",
    inspectionChecklistsPerProduct: "Ürün bazında muayene kontrol listeleri",
    noQualityPlans: "Kalite planı yok",
    checks: "Kontroller",
    newQualityPlan: "Yeni kalite planı",
    anyGeneral: "Tümü / genel",
    checklist: "Kontrol listesi",
    checkDescription: "Kontrol açıklaması",
    returnCreated: "İade oluşturuldu",
    rmaOpened: "İade yetkisi açıldı",
    customerReturnsInspectRestockRefundScrap: "Müşteri iadeleri: muayene, stoğa alma / geri ödeme / hurda",
    newReturn: "Yeni iade",
    noReturns: "İade yok",
    reason: "Neden",
    openRma: "İade yetkisi aç",
    salesOrder: "Satış siparişi",
    freightForwarders: "Nakliye Komisyoncuları",
    carriersForwardersInternationalMoves: "Uluslararası taşımalar için taşıyıcılar / komisyoncular",
    forwarders: "Komisyoncular",
    noFreightForwarders: "Nakliye komisyoncusu yok",
    newFreightForwarder: "Yeni nakliye komisyoncusu",
    priceLists2: "Fiyat Listeleri",
    customerChannelPricing: "Müşteri / kanal fiyatlandırması",
    lists: "Listeler",
    newList: "Yeni liste",
    noPriceLists: "Fiyat listesi yok",
    newPriceList: "Yeni fiyat listesi",
    product2: "Ürün…",
    issueRequired: "Sorun açıklaması zorunlu",
    returnMerchandiseAuthorization: "İade yetkilendirmesi",
    newRma: "Yeni iade yetkisi",
    noRmas: "İade yetkisi yok",
    return: "İade",
    createService: "Servis oluştur",
    productName: "Ürün adı",
    itemCreated: "Kayıt oluşturuldu.",
    codeAlreadyExistsThisType: "Bu tür için kod zaten var.",
    masterData: "Ana Veriler",
    referenceTypes: "Referans türleri",
    searchCodeName: "Kod veya ad ara…",
    noItems: "Kayıt yok",
    seedDefaultsAddNewReferenceItem: "Varsayılanları yükleyin veya bu tür için yeni bir referans kaydı ekleyin.",
    active: "aktif",
    inactive: "pasif",
    draft: "taslak",
    obsolete: "kullanım dışı",
    variantName: "Varyant adı",
    eGSizeLColorBlue: "ör. Beden L / Renk Mavi",
    engineeringRev: "Mühendislik revizyonu",
    specifications: "Teknik özellikler",
    materialDimensionsStandards: "Malzeme, ölçüler, standartlar…",
    userManagement: "Kullanıcı Yönetimi",
    adminPanel: "Yönetim Paneli",
    youDoNotHavePermissionManage: "Kullanıcıları yönetme yetkiniz yok.",
    users: "Kullanıcılar",
    allRoles: "Tüm roller",
    noUsers: "Kullanıcı yok",
    noUsersMatchCurrentFilters: "Filtrelere uyan kullanıcı yok.",
    role: "Rol",
    roleCatalog: "Rol kataloğu",
    level: "seviye",
    signedAs: "Giriş yapan:",
    moOutputReadyPackIntoBoxes: "Kutu / palete paketlenmeye hazır üretim çıktısı",
    fgFromManufacturing: "Üretimden gelen mamuller",
    noFinishedGoodsYet: "Henüz mamul yok",
    completeProductionOutputManufacturingOrderFirst: "Önce bir üretim emrinde üretim çıktısını tamamlayın",
    warehouseNotFound: "Depo bulunamadı",
    addLocation: "Lokasyon ekle",
    aisle: "Koridor",
    rack: "Raf",
    bin: "Göz",
    noLocations: "Lokasyon yok",
    printLocationLabels: "Lokasyon etiketleri",
    aisleRackBin: "Koridor/Raf/Göz",
    supplierNotFound: "Tedarikçi bulunamadı",
    profile: "Profil",
    edit: "Düzenle",
    productBothWarehousesAreRequired: "Ürün ve iki depo da zorunlu",
    sourceDestinationMustDiffer: "Kaynak ve hedef farklı olmalı",
    transferPostedNetStockUnchanged: "Transfer kaydedildi (toplam stok değişmedi)",
    stockTransfer: "Stok Transferi",
    moveQuantityBetweenWarehousesWithoutChanging: "Toplam stoğu değiştirmeden depolar arasında miktar taşıyın",
    transfer: "Transfer",
    fromWarehouse: "Çıkış deposu",
    warehouse2: "Varış deposu",
    min: "Min",
    max: "Maks",
    lot2: "Lot:",
    reversed: "ters kaydedildi",
    linkedDocuments: "Bağlı belgeler",
    fileUser: "dosya, kullanıcı…"
  }
};

export default tr;
